const THREE = require("three");
const GameObject = require("./GameObject.js");
const config = require("../config.js");
const UTILS = require("./utils.js");
const itemTypes = require("../data/itemTypes.js");
module.exports = function (RENDER, p15698, p15699) {
  this.aoOpac = 0;
  this.objects = [];
  this.pendingTriangles = [];
  this.pendingAIs = [];
  this.pendingBots = [];
  this.pendingLeaders = [];
  this.pathNodes = {};
  this.grids = {};
  this.objectives = [];
  this.domzones = [];
  this.scorezones = [];
  this.sites = [];
  this.flags = [];
  this.spawnables = [];
  this.pickups = [];
  this.destObjs = [];
  this.movedObjs = [];
  this.gates = [];
  this.mysteryBoxes = [];
  this.perkMachines = [];
  this.krumMachines = [];
  this.banks = [];
  this.interfaces = [];
  this.spinners = [];
  this.teleporters = [];
  this.timerObjs = [];
  this.playerObjs = [];
  this.spectateCams = {};
  this.envZones = [];
  this.serverNodes = [];
  this.mapAnchors = [];
  var v12693;
  var v12694;
  this.collision = function (p15700, p15701, p15702) {
    return p15700.x - p15700.width - p15702 <= p15701.x + p15701.width && p15700.x + p15700.width + p15702 >= p15701.x - p15701.width && p15700.z - p15700.length - p15702 <= p15701.z + p15701.length && p15700.z + p15700.length + p15702 >= p15701.z - p15701.length && p15700.y - p15700.height - p15702 <= p15701.y + p15701.height && p15700.y + p15700.height + p15702 >= p15701.y - p15701.height;
  };
  this.collisionC = function (p15703, p15704, p15705, p15706, p15707, p15708, p15709, p15710) {
    return p15703 - p15706 - p15710 <= p15709.x + p15709.width && p15703 + p15706 + p15710 >= p15709.x - p15709.width && p15705 - p15708 - p15710 <= p15709.z + p15709.length && p15705 + p15708 + p15710 >= p15709.z - p15709.length && p15704 - p15707 - p15710 <= p15709.y + p15709.height && p15704 + p15707 + p15710 >= p15709.y - p15709.height;
  };
  this.removeFromQuad = function (p15711, p15712) {
    var v12697;
    for (var v12696 in this.grids) {
      if (this.grids.hasOwnProperty(v12696)) {
        var v12697 = this.grids[v12696];
        for (var v12698 = v12697.length - 1; v12698 >= 0; --v12698) {
          if (v12697[v12698][p15711] == p15712) {
            v12697.splice(v12698, 1);
          }
        }
        if (v12697.length <= 0) {
          delete this.grids[v12696];
        }
      }
    }
  };
  this.applyToQuad = function (p15713, p15714) {
    var v12699;
    var v12700;
    var v12701;
    var v12702;
    var v12703;
    var v12704;
    if (p15714 || !p15713.complexColl) {
      if (p15714) {
        p15713.isTri = true;
        var v12705 = config.playerScale / 2 + 0.001;
        var v12706 = config.playerHeight + 0.001;
        p15713.minX = Math.min(p15713.a.x, p15713.b.x, p15713.c.x);
        p15713.minY = Math.min(p15713.a.y, p15713.b.y, p15713.c.y);
        p15713.minZ = Math.min(p15713.a.z, p15713.b.z, p15713.c.z);
        p15713.maxX = Math.max(p15713.a.x, p15713.b.x, p15713.c.x);
        p15713.maxY = Math.max(p15713.a.y, p15713.b.y, p15713.c.y);
        p15713.maxZ = Math.max(p15713.a.z, p15713.b.z, p15713.c.z);
        v12699 = Math.floor((p15713.minX - v12705) / config.quadSize);
        v12703 = Math.floor((p15713.minY - v12706) / config.quadSize);
        v12701 = Math.floor((p15713.minZ - v12705) / config.quadSize);
        v12700 = Math.ceil((p15713.maxX + v12705) / config.quadSize);
        v12704 = Math.ceil(p15713.maxY / config.quadSize);
        v12702 = Math.ceil((p15713.maxZ + v12705) / config.quadSize);
      } else if (!p15713.complexColl) {
        var v12707 = p15713.width + config.playerScale + 0.1;
        var v12708 = p15713.length + config.playerScale + 0.1;
        var v12709 = p15713.height + config.playerHeight + 0.1;
        v12699 = Math.floor((p15713.x - v12707) / config.quadSize);
        v12700 = Math.floor((p15713.x + v12707) / config.quadSize);
        v12701 = Math.floor((p15713.z - v12708) / config.quadSize);
        v12702 = Math.floor((p15713.z + v12708) / config.quadSize);
        v12703 = Math.floor((p15713.y - v12709) / config.quadSize);
        v12704 = Math.floor((p15713.y + v12709 + (p15713.isBorder ? config.borderH : 0)) / config.quadSize);
      }
      for (var vV12699 = v12699; vV12699 <= v12700; ++vV12699) {
        for (var vV12701 = v12701; vV12701 <= v12702; ++vV12701) {
          var v12710;
          for (var vV12703 = v12703; vV12703 <= v12704; ++vV12703) {
            v12710 = vV12699 + "_" + vV12703 + "_" + vV12701;
            if (!this.grids[v12710]) {
              this.grids[v12710] = [];
            }
            this.grids[v12710].push(p15713);
          }
        }
      }
    }
  };
  this.genQuads = function () {
    var vLN02279 = 0;
    if (this.pendingTriangles) {
      this.pendingTriangles.length / 9;
      for (var vLN02281 = 0; vLN02281 < this.pendingTriangles.length; vLN02281 += 9) {
        const v12711 = new THREE.Vector3(this.pendingTriangles[vLN02281], this.pendingTriangles[vLN02281 + 1], this.pendingTriangles[vLN02281 + 2]);
        const v12712 = new THREE.Vector3(this.pendingTriangles[vLN02281 + 3], this.pendingTriangles[vLN02281 + 4], this.pendingTriangles[vLN02281 + 5]);
        const v12713 = new THREE.Vector3(this.pendingTriangles[vLN02281 + 6], this.pendingTriangles[vLN02281 + 7], this.pendingTriangles[vLN02281 + 8]);
        var v12714 = new THREE.Triangle(v12711, v12712, v12713);
        vLN02279++;
        this.applyToQuad(v12714, true);
      }
      this.pendingTriangles.length = 0;
    }
    for (var vLN02281 = 0; vLN02281 < this.objects.length; ++vLN02281) {
      vLN02279++;
      this.applyToQuad(this.objects[vLN02281]);
    }
  };
  var vA699 = [];
  this.getGridArrays = function (p15715, p15716, p15717, p15718) {
    var v12715 = Math.floor(p15715 / config.quadSize);
    var v12716 = Math.floor(p15716 / config.quadSize);
    var v12717 = Math.floor(p15717 / config.quadSize);
    if (p15718) {
      var v12718 = Math.ceil(p15718 / config.quadSize);
      vA699.length = 0;
      if (this.grids[v12715 + "_" + v12716 + "_" + v12717]) {
        vA699.push(this.grids[v12715 + "_" + v12716 + "_" + v12717]);
      }
      var vLN1164 = 1;
      for (var vLN02282 = 0; vLN02282 < v12718; ++vLN02282) {
        if (this.grids[v12715 + vLN1164 + "_" + v12716 + "_" + v12717]) {
          vA699.push(this.grids[v12715 + vLN1164 + "_" + v12716 + "_" + v12717]);
        }
        if (this.grids[v12715 - vLN1164 + "_" + v12716 + "_" + v12717]) {
          vA699.push(this.grids[v12715 - vLN1164 + "_" + v12716 + "_" + v12717]);
        }
        if (this.grids[v12715 + "_" + v12716 + "_" + (v12717 + vLN1164)]) {
          vA699.push(this.grids[v12715 + "_" + v12716 + "_" + (v12717 + vLN1164)]);
        }
        if (this.grids[v12715 + "_" + v12716 + "_" + (v12717 - vLN1164)]) {
          vA699.push(this.grids[v12715 + "_" + v12716 + "_" + (v12717 - vLN1164)]);
        }
        vLN1164++;
      }
      return vA699;
    }
    if (this.grids[v12715 + "_" + v12716 + "_" + v12717]) {
      return this.grids[v12715 + "_" + v12716 + "_" + v12717];
    } else {
      return undefined;
    }
  };
  this.checkPos = function (p15719, p15720, p15721, p15722, p15723) {
    for (var vLN02283 = 0; vLN02283 < this.objects.length; ++vLN02283) {
      if (this.objects[vLN02283] != p15722 && this.objects[vLN02283] != p15723 && !this.objects[vLN02283].ramp && UTILS.pointInBox3D(p15719, p15720, p15721, this.objects[vLN02283])) {
        return false;
      }
    }
    return true;
  };
  this.findByUid = function (p15724, p15725) {
    v12693 = p15725 || this.objects;
    for (var vLN02284 = 0; vLN02284 < v12693.length; ++vLN02284) {
      if (v12693[vLN02284].uid === p15724) {
        return v12693[vLN02284];
      }
    }
    return null;
  };
  this.findBySid = function (p15726, p15727) {
    v12693 = p15727 || this.objects;
    for (var vLN02285 = 0; vLN02285 < v12693.length; ++vLN02285) {
      if (v12693[vLN02285].sid === p15726) {
        return v12693[vLN02285];
      }
    }
    return null;
  };
  this.getZoneDat = function (p15728, p15729) {
    return {
      src: "zone_r",
      texSrc: "zone_" + (p15729 ? p15728 == p15729.team ? "b" : "r" : "r") + "_1",
      noGroup: true,
      forceTex: true,
      mat: THREE.MeshBasicMaterial,
      transparent: true,
      depthWrite: false,
      side: 2,
      autoMatrix: true,
      scale: 0,
      sameGlow: true,
      glowText: true,
      emissive: p15729 ? p15728 == p15729.team ? 4360861 : 8729652 : 8729652,
      pulsT: 1
    };
  };
  this.getFlagDat = function (p15730, p15731) {
    var v12719 = p15731 ? p15730 == p15731.team ? "1" : "0" : "0";
    return {
      src: "crystal_0",
      texSrc: "crystal_" + v12719,
      noGroup: true,
      noShadow: true,
      noFog: true,
      emissive: v12719 == "0" ? 8729652 : 4360861,
      noEmisTex: true
    };
  };
  this.addFlag = function (p15732, p15733, p15734, p15735) {
    if (p15735 != -1) {
      p15735 += 1;
    }
    var v12720 = null;
    if (RENDER) {
      v12720 = RENDER.loadMesh(this.getFlagDat(p15735), p15732, p15733 + config.flagOff, p15734, 0, config.flagScale, RENDER.scene);
      v12720.zoneMesh = RENDER.addCube(p15732, p15733, p15734, config.flagZoneS, 5, config.flagZoneS, [1, 1, 0, 0, 1, 1], this.getZoneDat(p15735));
    }
    var v12721 = new GameObject({
      uid: this.objects.length,
      meshRef: v12720,
      x: p15732,
      z: p15734,
      y: p15733 + config.flagScale / 2 + config.flagOff,
      w: config.flagScale,
      l: config.flagScale,
      h: config.flagScale / 2,
      img: {
        x: p15732,
        y: p15733,
        z: p15734
      },
      team: p15735,
      neutral: p15735 == -1 ? 1 : undefined,
      flag: true,
      noShoot: true,
      complexMesh: true,
      noMinimap: true
    });
    this.flags.push(v12721);
    this.objects.push(v12721);
    var v12722 = new GameObject({
      uid: this.objects.length,
      x: p15732,
      z: p15734,
      y: p15733 + config.flagZoneH / 2,
      w: config.flagZoneS / 2,
      l: config.flagZoneS / 2,
      h: config.flagZoneH / 2,
      team: p15735,
      neutral: p15735 == -1 ? 1 : undefined,
      trigger: true,
      noShoot: true,
      complexMesh: true,
      noMinimap: true
    });
    v12722.flagObj = v12721;
    this.objects.push(v12722);
  };
  this.addPad = function (p15736, p15737, p15738, p15739, p15740, p15741, p15742, p15743) {
    p15742 = p15742 || {};
    p15742.bounce = UTILS.limitMM(parseFloat(p15742.bounce) || 0, -3, 3).round(2);
    p15742.direction = UTILS.limitMM(parseInt(p15742.direction) || 0, 0, 5);
    var v12724 = null;
    if (RENDER && !p15742.noVis) {
      var v12724 = RENDER.loadMesh({
        isMdl: true,
        src: "pad_0",
        forceMat: THREE.StrippedLambertMaterial,
        vertexColors: true
      }, p15736, p15737 + 0.4 + (p15742.direction >= 2 ? p15741 / 2 : 0), p15738, p15743, 3.6, RENDER.scene);
      var v12725 = p15742.direction < 2 ? Math.min(p15739, p15740) : Math.min(p15741, p15742.direction & 1 ? p15739 : p15740);
      var v12726 = Math.max(v12725 / 10, 0.1);
      v12724.scale.x = v12726 * 3.6;
      v12724.scale.z = v12726 * 3.6;
      if (p15742.direction >= 2) {
        v12724.rotateZ(-Math.PI / 2);
        v12724.rotateX(Math.PI / 2 * (p15742.direction - 2));
      } else if (p15742.direction == 1) {
        v12724.rotateX(Math.PI);
      }
    }
    var v12727 = new GameObject({
      uid: this.objects.length,
      meshRef: v12724,
      x: p15736,
      z: p15738,
      y: p15737,
      w: p15739 / 2,
      l: p15740 / 2,
      h: Math.max(p15741, 3),
      xR: p15742.xR,
      yR: p15742.yR,
      zR: p15742.zR,
      d: p15742.direction,
      jumpPad: true,
      bounce: p15742.bounce || 0,
      crouch: p15742.crouch,
      complexMesh: true,
      noMinimap: true
    });
    this.objects.push(v12727);
  };
  this.genWeaponMeshData = function (p15744, p15745, p15746) {
    p15746 = p15746 || {};
    return {
      src: "weapons/" + p15744.src + (p15746.mid == null ? "" : "_" + p15746.mid),
      texSrc: p15746.mid == null ? p15746.tex ? p15746.tex : p15746 && p15746.id != null ? "weapons/skins/" + p15744.src + "_" + p15746.id : null : UTILS.getReModel(p15745, p15746),
      tFilter: 1006,
      transparent: p15746.opac != null || p15744.seeThrough,
      emissive: p15744.transp ? "#ffffff" : null,
      noGroup: true,
      uv2: true,
      shininess: p15744.shine || 60,
      specular: 2697513,
      shadowsR: true,
      noShadow: true,
      noFog: true
    };
  };
  this.addWeapon = function (p15747, p15748, p15749, p15750, p15751, p15752, p15753, p15754) {
    p15750 = p15750 || {};
    if (p15750.randomGroup) {
      p15750.randomGroup = UTILS.limitMM(parseInt(p15750.randomGroup) || 0, 1, 10000);
    }
    var v12728 = null;
    if (p15750.weaponId == 12) {
      p15750.weaponId = 0;
    }
    if (RENDER) {
      let v12729 = p15754[p15750.weaponId];
      let v12730 = this.genWeaponMeshData(v12729);
      if (p15750.noTex) {
        v12730.noTex = true;
      }
      v12728 = RENDER.loadMesh(v12730, p15747, p15748 + config.pickupOff, p15749, 0, v12729.scale * (v12729.equipment ? 2 : 1), RENDER.scene);
      v12728.visible = false;
      v12728.rotateY(p15751 || 0);
      v12728.rotateX((p15752 || 0) - (v12729.equipment ? 0 : Math.PI / 2));
      v12728.rotateZ((p15753 || 0) - (v12729.equipment ? Math.PI / 2 : 0));
    }
    if (p15750.interactMsg && UTILS.isString(p15750.interactMsg) && p15750.interactMsg != "") {
      if (p15750.interactMsg.length > 70) {
        p15750.interactMsg = undefined;
      }
      if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(p15750.interactMsg)) {
        p15750.interactMsg = undefined;
      }
    } else {
      p15750.interactMsg = undefined;
    }
    var v12731 = new GameObject({
      uid: this.objects.length,
      meshRef: v12728,
      x: p15747,
      z: p15749,
      y: p15748 + config.pickupZoneH / 2,
      w: config.pickupZoneX,
      l: config.pickupZoneZ,
      h: config.pickupZoneH * 2,
      pickup: p15750.weaponId,
      pickupRep: !p15750.noRep,
      orgPickup: p15750.weaponId,
      scoreP: p15750.scoreP,
      noMsg: p15750.noMsg,
      method: p15750.method || undefined,
      trigger: true,
      noShoot: true,
      complexMesh: true,
      pickupRand: p15750.random,
      pickupRandGroup: p15750.randomGroup || undefined,
      team: p15750.team,
      interactMsg: p15750.interactMsg,
      showIcon: p15750.showIcon,
      noMinimap: true,
      noTex: p15750.noTex
    });
    this.pickups.push(v12731);
    this.objects.push(v12731);
  };
  this.addShowcase = function (p15755, p15756, p15757, p15758, p15759, p15760, p15761, p15762, p15763, p15764) {
    p15762 = p15762 || {};
    if (p15762.mSize) {
      p15762.mSize = UTILS.limitMM(p15762.mSize, 0.01, 100);
    }
    p15762.spin = UTILS.limitMM(p15762.spin, -20, 20);
    p15762.spinAxis = UTILS.limitMM(p15762.spinAxis, 0, 1);
    if (p15762.spin != 0) {
      p15762.rAnim = (p15762.spin || 0) * config.diskSpin;
      p15762.rAnimA = p15762.spinAxis ? "x" : "y";
    }
    var v12732 = p15764.skins[p15762.itemID || 0];
    if (!!v12732 && (!v12732 || !v12732.type || v12732.type != itemTypes.SPRAY && v12732.type != itemTypes.DYE && v12732.type != itemTypes.COLLECTIBLE && v12732.type != itemTypes.WRIST && v12732.type != itemTypes.TICKET && v12732.type != itemTypes.PLAYER_CARD)) {
      var v12733 = p15763[v12732.weapon - 1] || {};
      p15756 += p15760 * (v12732.type == itemTypes.CHARM ? 2 : 1);
      if (!RENDER || !!RENDER.mapDet) {
        if (RENDER) {
          RENDER[v12732.hasAnim ? "loadAnimMesh" : "loadMesh"]({
            local: v12732.local,
            localM: v12732.localM,
            fileExt: v12732.fileExt,
            animS: v12732.animS,
            hasAnim: v12732.hasAnim,
            src: p15764.types[v12732.assetType || v12732.type || 0] + (v12732.assetType || v12732.type ? v12732.id : v12732.weapon) + (v12732.mid == null ? "" : "_" + v12732.mid),
            texSrc: v12732.mid == null ? v12732.type && v12732.type == itemTypes.MELEE ? v12732.pat ? v12732.tex : "melee/melee_" + (v12732.id || 0) + (v12732.tex ? "_" + v12732.tex : "") : v12732.type ? v12732.tex ? p15764.types[v12732.assetType || v12732.type || 0] + v12732.id + "_" + v12732.tex : null : v12732.tex ? v12732.tex : "weapons/skins/weapon_" + v12732.weapon + "_" + v12732.id : UTILS.getReModel(p15764, v12732),
            rotT: v12732.rotT,
            movT: v12732.movT,
            movE: v12732.movE,
            pulsT: v12732.pulsT,
            repeatY: v12732.tileS || 0,
            repeatX: v12732.tileS || 0,
            frames: v12732.frames,
            frameT: v12732.frameT,
            sameEnv: v12732.sameEnv,
            env: v12732.env || v12732.sameEnv ? v12732.env || 3 : undefined,
            sameGlow: v12732.sameGlow,
            glowText: v12732.glow || v12732.sameGlow,
            emissive: v12732.glow || v12732.sameGlow ? "#ffffff" : null,
            rgb: v12732.rgb,
            rgbS: v12732.rgbS,
            rAnim: p15762.rAnim || v12732.rAnim,
            rAnimA: p15762.rAnimA || v12732.rAnimA,
            rAnimT: p15762.rAnimT || v12732.rAnimT,
            rAniM: p15762.rAnimM || v12732.rAnimM,
            useWireframe: v12732.wire,
            side: v12732.side || 0,
            opacity: v12732.opac || 1,
            shaderNum: v12732.shaderNum,
            video: v12732.video,
            projection: v12732.projection,
            itemID: p15762.itemID || 0,
            shininess: v12733.shine || 60,
            specular: 2697513,
            shadowsR: true,
            transparent: v12732.opac != null || v12732.trans || v12733.seeThrough || false
          }, p15755, p15756, p15757, p15758, (p15762.mSize || 1) * (v12732.mScl || v12733.scale || 1), RENDER.scene, !p15762.spin);
        }
      }
    }
  };
  this.addObjective = function (p15765, p15766, p15767, p15768, p15769, p15770, p15771) {
    p15771 = p15771 || {};
    var v12734;
    if (RENDER) {
      v12734 = RENDER.addCube(p15765, p15766, p15767, p15768, 5, p15769, [1, 1, 0, 0, 1, 1], {
        src: "objective_4",
        scale: 0,
        noGroup: true,
        forceTex: true,
        mat: THREE.MeshBasicMaterial,
        transparent: true,
        depthWrite: false,
        side: 2,
        autoMatrix: true,
        sameGlow: true,
        glowText: true,
        emissive: "#ffd542",
        pulsT: 1
      });
      v12734.visible = false;
    }
    var vLN02286 = 0;
    if (p15771.objId) {
      vLN02286 = UTILS.limitMM(parseInt(p15771.objId) || 1, 1, 10) - 1;
    } else {
      var v12735 = false;
      for (var vLN02287 = 0; vLN02287 < this.objectives.length; vLN02287++) {
        if (this.objectives[vLN02287].uid > vLN02286) {
          vLN02286 = this.objectives[vLN02287].uid + 1;
          v12735 = true;
        } else if (this.objectives[vLN02287].uid == vLN02286) {
          vLN02286++;
        }
      }
      if (!v12735) {
        vLN02286 = this.objectives.length;
      }
    }
    this.objectives.push({
      uid: vLN02286,
      x: p15765,
      z: p15767,
      y: p15766 + p15770 / 2,
      mesh: v12734,
      width: p15768 / 2,
      length: p15769 / 2,
      height: p15770 / 2,
      onZone: 0
    });
  };
  this.addDominationZone = function (p15772, p15773, p15774, p15775, p15776, p15777) {
    var v12736;
    if (RENDER) {
      v12736 = RENDER.addCube(p15772, p15773, p15774, p15775, 5, p15776, [1, 1, 0, 0, 1, 1], {
        src: "objective_4",
        noGroup: true,
        forceTex: true,
        mat: THREE.MeshBasicMaterial,
        transparent: true,
        depthWrite: false,
        side: 2,
        autoMatrix: true,
        scale: 0
      });
      v12736.visible = false;
    }
    this.domzones.push({
      uid: this.domzones.length,
      x: p15772,
      z: p15774,
      y: p15773 + p15777 / 2,
      meshRef: v12736,
      width: p15775 / 2,
      length: p15776 / 2,
      height: p15777 / 2,
      capturedBy: null,
      captureT: 0,
      lastTeamOn: null,
      teamsOn: [],
      onPoint: []
    });
  };
  this.addBombSite = function (p15778, p15779, p15780, p15781, p15782, p15783) {
    var v12737;
    if (RENDER) {
      v12737 = RENDER.addCube(p15778, p15779 + 1, p15780, p15781, p15783, p15782, [1, 1, 0, 0, 1, 1], {
        src: "objective_b",
        noGroup: true,
        movT: 0.00006,
        forceTex: true,
        shadowsR: true,
        transparent: true,
        depthWrite: false,
        side: 2,
        autoMatrix: true
      });
      v12737.visible = false;
    }
    this.sites.push({
      x: p15778,
      z: p15780,
      y: p15779 + p15783 / 2,
      meshRef: v12737,
      width: p15781 / 2,
      length: p15782 / 2,
      height: p15783 / 2
    });
  };
  this.addDeathZone = function (p15784, p15785, p15786, p15787, p15788, p15789, p15790) {
    p15790 = p15790 || {};
    p15790.spawnChance = UTILS.limitMM(parseFloat(p15790.spawnChance) || 0, 0, 100).round(2);
    if (!p15790.spawnChance) {
      p15790.spawnChance = undefined;
    }
    if (p15790.health) {
      p15790.canDest = true;
    }
    let v12738 = new GameObject({
      x: p15784,
      z: p15786,
      y: p15785 + p15789 / 2,
      w: p15787 / 2,
      l: p15788 / 2,
      h: p15789 / 2,
      kill: true,
      noShoot: true,
      complexMesh: true,
      uid: this.objects.length,
      health: p15790.health || undefined,
      canDest: p15790.canDest,
      startDest: p15790.canDest && p15790.startDest,
      spawnChance: p15790.spawnChance,
      respawnT: UTILS.isNumber(p15790.respawnT) && p15790.respawnT > 0 ? p15790.respawnT : undefined,
      respawnR: p15790.respawnR,
      interface: p15790.interface,
      noMinimap: true
    });
    this.objects.push(v12738);
    this.addHelpers(p15790, v12738.uid);
  };
  this.addScoreZone = function (p15791, p15792, p15793, p15794, p15795, p15796, p15797) {
    var v12739 = this.objects.length;
    this.scorezones.push({
      uid: v12739
    });
    this.objects.push(new GameObject({
      uid: v12739,
      x: p15791,
      z: p15793,
      y: p15792 + p15796 / 2,
      w: p15794 / 2,
      l: p15795 / 2,
      h: p15796 / 2,
      score: true,
      scoreP: p15797,
      noShoot: true,
      complexMesh: true,
      noMinimap: true
    }));
  };
  this.addPremiumZone = function (p15798, p15799, p15800, p15801, p15802, p15803, p15804) {
    p15804 = p15804 || {};
    p15804.spawnChance = UTILS.limitMM(parseFloat(p15804.spawnChance) || 0, 0, 100).round(2);
    if (!p15804.spawnChance) {
      p15804.spawnChance = undefined;
    }
    if (p15804.health) {
      p15804.canDest = true;
    }
    let v12740 = new GameObject({
      x: p15798,
      z: p15800,
      y: p15799 + p15803 / 2,
      w: p15801 / 2,
      l: p15802 / 2,
      h: p15803 / 2,
      isBorder: p15804.isBorder,
      noShoot: true,
      premium: true,
      complexMesh: true,
      uid: this.objects.length,
      health: p15804.health || undefined,
      canDest: p15804.canDest,
      startDest: p15804.canDest && p15804.startDest,
      spawnChance: p15804.spawnChance,
      respawnT: UTILS.isNumber(p15804.respawnT) && p15804.respawnT > 0 ? p15804.respawnT : undefined,
      respawnR: p15804.respawnR,
      interface: p15804.interface,
      noMinimap: true
    });
    this.objects.push(v12740);
    this.addHelpers(p15804, v12740.uid);
  };
  this.addVerifiedZone = function (p15805, p15806, p15807, p15808, p15809, p15810, p15811) {
    p15811 = p15811 || {};
    p15811.spawnChance = UTILS.limitMM(parseFloat(p15811.spawnChance) || 0, 0, 100).round(2);
    if (!p15811.spawnChance) {
      p15811.spawnChance = undefined;
    }
    if (p15811.health) {
      p15811.canDest = true;
    }
    let v12741 = new GameObject({
      x: p15805,
      z: p15807,
      y: p15806 + p15810 / 2,
      w: p15808 / 2,
      l: p15809 / 2,
      h: p15810 / 2,
      isBorder: p15811.isBorder,
      noShoot: true,
      complexMesh: true,
      verified: true,
      uid: this.objects.length,
      health: p15811.health || undefined,
      canDest: p15811.canDest,
      startDest: p15811.canDest && p15811.startDest,
      spawnChance: p15811.spawnChance,
      respawnT: UTILS.isNumber(p15811.respawnT) && p15811.respawnT > 0 ? p15811.respawnT : undefined,
      respawnR: p15811.respawnR,
      interface: p15811.interface,
      noMinimap: true
    });
    this.objects.push(v12741);
    this.addHelpers(p15811, v12741.uid);
  };
  this.addPartnerZone = function (p15812, p15813, p15814, p15815, p15816, p15817, p15818) {
    p15818 = p15818 || {};
    p15818.spawnChance = UTILS.limitMM(parseFloat(p15818.spawnChance) || 0, 0, 100).round(2);
    if (!p15818.spawnChance) {
      p15818.spawnChance = undefined;
    }
    if (p15818.health) {
      p15818.canDest = true;
    }
    let v12742 = new GameObject({
      x: p15812,
      z: p15814,
      y: p15813 + p15817 / 2,
      w: p15815 / 2,
      l: p15816 / 2,
      h: p15817 / 2,
      isBorder: p15818.isBorder,
      noShoot: true,
      partner: true,
      complexMesh: true,
      uid: this.objects.length,
      health: p15818.health || undefined,
      canDest: p15818.canDest,
      startDest: p15818.canDest && p15818.startDest,
      spawnChance: p15818.spawnChance,
      respawnT: UTILS.isNumber(p15818.respawnT) && p15818.respawnT > 0 ? p15818.respawnT : undefined,
      respawnR: p15818.respawnR,
      interface: p15818.interface,
      noMinimap: true
    });
    this.objects.push(v12742);
    this.addHelpers(p15818, v12742.uid);
  };
  this.addTeamZone = function (p15819, p15820, p15821, p15822, p15823, p15824, p15825) {
    p15825 = p15825 || {};
    p15825.spawnChance = UTILS.limitMM(parseFloat(p15825.spawnChance) || 0, 0, 100).round(2);
    if (!p15825.spawnChance) {
      p15825.spawnChance = undefined;
    }
    if (p15825.health) {
      p15825.canDest = true;
    }
    let v12743 = new GameObject({
      x: p15819,
      z: p15821,
      y: p15820 + p15824 / 2,
      w: p15822 / 2,
      l: p15823 / 2,
      h: p15824 / 2,
      isBorder: p15825.isBorder,
      noShoot: true,
      teamZ: true,
      team: p15825.team,
      complexMesh: true,
      uid: this.objects.length,
      health: p15825.health || undefined,
      canDest: p15825.canDest,
      startDest: p15825.canDest && p15825.startDest,
      spawnChance: p15825.spawnChance,
      respawnT: UTILS.isNumber(p15825.respawnT) && p15825.respawnT > 0 ? p15825.respawnT : undefined,
      respawnR: p15825.respawnR,
      interface: p15825.interface,
      noMinimap: true
    });
    this.objects.push(v12743);
    this.addHelpers(p15825, v12743.uid);
  };
  this.addKRZone = function (p15826, p15827, p15828, p15829, p15830, p15831, p15832) {
    p15832 = p15832 || {};
    p15832.amount = UTILS.limitMM(p15832.amount, 0, 10000000);
    p15832.spawnChance = UTILS.limitMM(parseFloat(p15832.spawnChance) || 0, 0, 100).round(2);
    if (!p15832.spawnChance) {
      p15832.spawnChance = undefined;
    }
    if (p15832.health) {
      p15832.canDest = true;
    }
    let v12744 = new GameObject({
      x: p15826,
      z: p15828,
      y: p15827 + p15831 / 2,
      w: p15829 / 2,
      l: p15830 / 2,
      h: p15831 / 2,
      isBorder: p15832.isBorder,
      noShoot: true,
      kr: true,
      amount: p15832.amount,
      complexMesh: true,
      uid: this.objects.length,
      health: p15832.health || undefined,
      canDest: p15832.canDest,
      startDest: p15832.canDest && p15832.startDest,
      spawnChance: p15832.spawnChance,
      respawnT: UTILS.isNumber(p15832.respawnT) && p15832.respawnT > 0 ? p15832.respawnT : undefined,
      respawnR: p15832.respawnR,
      interface: p15832.interface,
      noMinimap: true
    });
    this.objects.push(v12744);
    this.addHelpers(p15832, v12744.uid);
  };
  this.addNOPVPZone = function (p15833, p15834, p15835, p15836, p15837, p15838, p15839) {
    p15839 = p15839 || {};
    p15839.spawnChance = UTILS.limitMM(parseFloat(p15839.spawnChance) || 0, 0, 100).round(2);
    if (!p15839.spawnChance) {
      p15839.spawnChance = undefined;
    }
    if (p15839.health) {
      p15839.canDest = true;
    }
    let v12745 = new GameObject({
      x: p15833,
      z: p15835,
      y: p15834 + p15838 / 2,
      w: p15836 / 2,
      l: p15837 / 2,
      h: p15838 / 2,
      isBorder: p15839.isBorder,
      noShoot: true,
      noPVP: true,
      complexMesh: true,
      uid: this.objects.length,
      health: p15839.health || undefined,
      canDest: p15839.canDest,
      startDest: p15839.canDest && p15839.startDest,
      spawnChance: p15839.spawnChance,
      respawnT: UTILS.isNumber(p15839.respawnT) && p15839.respawnT > 0 ? p15839.respawnT : undefined,
      respawnR: p15839.respawnR,
      interface: p15839.interface,
      noMinimap: true
    });
    this.objects.push(v12745);
    this.addHelpers(p15839, v12745.uid);
  };
  this.addPVPZone = function (p15840, p15841, p15842, p15843, p15844, p15845, p15846) {
    p15846 = p15846 || {};
    p15846.spawnChance = UTILS.limitMM(parseFloat(p15846.spawnChance) || 0, 0, 100).round(2);
    if (!p15846.spawnChance) {
      p15846.spawnChance = undefined;
    }
    if (p15846.health) {
      p15846.canDest = true;
    }
    let v12746 = new GameObject({
      x: p15840,
      z: p15842,
      y: p15841 + p15845 / 2,
      w: p15843 / 2,
      l: p15844 / 2,
      h: p15845 / 2,
      isBorder: p15846.isBorder,
      noShoot: true,
      forcePVP: true,
      complexMesh: true,
      uid: this.objects.length,
      health: p15846.health || undefined,
      canDest: p15846.canDest,
      startDest: p15846.canDest && p15846.startDest,
      spawnChance: p15846.spawnChance,
      respawnT: UTILS.isNumber(p15846.respawnT) && p15846.respawnT > 0 ? p15846.respawnT : undefined,
      respawnR: p15846.respawnR,
      interface: p15846.interface,
      noMinimap: true
    });
    this.objects.push(v12746);
    this.addHelpers(p15846, v12746.uid);
  };
  this.addKPDZone = function (p15847, p15848, p15849, p15850, p15851, p15852, p15853) {
    p15853 = p15853 || {};
    p15853.spawnChance = UTILS.limitMM(parseFloat(p15853.spawnChance) || 0, 0, 100).round(2);
    if (!p15853.spawnChance) {
      p15853.spawnChance = undefined;
    }
    if (p15853.health) {
      p15853.canDest = true;
    }
    let v12747 = new GameObject({
      x: p15847,
      z: p15849,
      y: p15848 + p15852 / 2,
      w: p15850 / 2,
      l: p15851 / 2,
      h: p15852 / 2,
      isBorder: p15853.isBorder,
      noShoot: true,
      kpd: true,
      complexMesh: true,
      uid: this.objects.length,
      health: p15853.health || undefined,
      canDest: p15853.canDest,
      startDest: p15853.canDest && p15853.startDest,
      spawnChance: p15853.spawnChance,
      respawnT: UTILS.isNumber(p15853.respawnT) && p15853.respawnT > 0 ? p15853.respawnT : undefined,
      respawnR: p15853.respawnR,
      interface: p15853.interface,
      noMinimap: true
    });
    this.objects.push(v12747);
    this.addHelpers(p15853, v12747.uid);
  };
  this.addEnvironmentZone = function (p15854, p15855, p15856, p15857, p15858, p15859, p15860, p15861) {
    p15860 = p15860 || {};
    var vO407 = {
      ambInd: p15860.ambInd == null ? 1 : parseInt(p15860.ambInd || 0),
      ambIndC: parseInt(p15860.ambIndC || 0),
      skyDome: !!p15860.skyDome,
      skyDomeCol0: UTILS.isHexColor(p15860.skyDomeCol0) ? p15860.skyDomeCol0 : "#74a4b9",
      skyDomeCol1: UTILS.isHexColor(p15860.skyDomeCol1) ? p15860.skyDomeCol1 : "#dce8ed",
      skyDomeCol2: UTILS.isHexColor(p15860.skyDomeCol2) ? p15860.skyDomeCol2 : "#dce8ed",
      skyDomeEmis: UTILS.isHexColor(p15860.skyDomeEmis) ? p15860.skyDomeEmis : "#000000",
      skyDomeEmisTex: p15860.skyDomeEmisTex && !/[^\dtlnesacdgxufq]+/gmi.test(p15860.skyDomeEmisTex) ? p15860.skyDomeEmisTex : 0,
      skyDomeTex: !!p15860.skyDomeTex,
      skyDomeTexA: p15860.skyDomeTexA && !/[^\dtlnesacdgxufq]+/gmi.test(p15860.skyDomeTexA) ? p15860.skyDomeTexA : 0,
      skyDomeMovD: parseFloat(p15860.skyDomeMovD || 0),
      skyDomeMovT: parseFloat(p15860.skyDomeMovT || 0),
      shadowR: p15860.shadowR == null ? config.shadowRes : parseInt(p15860.shadowR || 0),
      shadowD: p15860.shadowD == null ? config.shadowDst : parseInt(p15860.shadowD || 0),
      ambient: UTILS.isHexColor(p15860.ambientC) ? p15860.ambientC : "#97a0a8",
      ambientI: p15860.ambientI == null ? config.ambIntensity : parseFloat(p15860.ambientI || 0),
      light: UTILS.isHexColor(p15860.light) ? p15860.light : "#f2f8fc",
      lightD: p15860.lightD == null ? config.lightDistance : parseInt(p15860.lightD || 0),
      lightI: p15860.lightI == null ? config.lightIntensity : parseFloat(p15860.lightI || 0),
      sunAngX: p15860.sunAngX == null ? config.sunAngleX : parseInt(p15860.sunAngX || 0),
      sunAngY: p15860.sunAngY == null ? config.sunAngleY : parseInt(p15860.sunAngY || 0),
      sky: UTILS.isHexColor(p15860.sky) ? p15860.sky : "#dce8ed",
      fog: UTILS.isHexColor(p15860.fogC) ? p15860.fogC : "#8d9aa0",
      fogD: p15860.fogD == null ? 2000 : parseInt(p15860.fogD || 0),
      correctLights: !!p15860.correctLights,
      toneMapping: parseFloat(p15860.toneMapping || 0),
      toneMappingExposure: p15860.toneMappingExposure == null ? 1 : parseFloat(p15860.toneMappingExposure || 0),
      outputEncoding: parseInt(p15860.outputEncoding || 0)
    };
    var vO408 = {
      x: p15854,
      z: p15856,
      y: p15855 + p15859 / 2,
      w: p15857 / 2,
      l: p15858 / 2,
      h: p15859 / 2,
      data: vO407
    };
    if (p15861) {
      return vO408;
    } else {
      this.envZones.push(vO408);
      return;
    }
  };
  this.addCheckPoint = function (p15862, p15863, p15864, p15865, p15866, p15867, p15868) {
    p15868 = p15868 || {};
    var v12748 = this.objects.length;
    this.objects.push(new GameObject({
      uid: v12748,
      x: p15862,
      z: p15864,
      y: p15863 + p15867 / 2,
      w: p15865 / 2,
      l: p15866 / 2,
      h: p15867 / 2,
      d: parseInt(p15868.direction) || 0,
      checkpoint: true,
      singleUse: p15868.singleUse,
      noShoot: true,
      complexMesh: true,
      team: p15868.team,
      noMinimap: true
    }));
  };
  this.addTeleporter = function (p15869, p15870, p15871, p15872, p15873, p15874, p15875) {
    p15875 = p15875 || {};
    p15875.channel = UTILS.limitMM(p15875.channel, 0, 100);
    var v12749 = new GameObject({
      uid: this.objects.length,
      x: p15869,
      z: p15871,
      y: p15870 + p15874 / 2,
      w: p15872 / 2,
      l: p15873 / 2,
      h: p15874 / 2,
      d: parseInt(p15875.direction) || 0,
      fd: p15875.forceDir,
      teleporter: true,
      telCheckPoint: p15875.telCheckPoint,
      telCooldown: 0,
      channel: p15875.channel || 0,
      node: p15875.node || 0,
      momentum: p15875.momentum,
      noShoot: true,
      complexMesh: true,
      team: p15875.team,
      noMinimap: true
    });
    this.objects.push(v12749);
    this.teleporters.push(v12749);
  };
  var vA700 = ["#444532", "#484a2f", "#4b4d2e", "#55573b"];
  var vA701 = [{
    name: "Tiny Oak",
    height: [30],
    scales: [1.5, 1.6],
    rar: [10],
    gen: function (p15876, p15877, p15878, p15879) {
      if (RENDER) {
        RENDER.addSphere(p15876[0], p15876[1] + p15877 - 1, p15876[2], 25, 34, 25, {
          src: "default",
          shadows: true,
          vNoise: 0.3,
          xR: p15878,
          coat: p15879.cot,
          colr: p15879.col || vA700[p15878 % vA700.length]
        });
      }
    }
  }, {
    name: "Square Oak",
    height: [65, 50],
    scales: [4, 5],
    rar: [4, 8, 9],
    gen: function (p15880, p15881, p15882, p15883) {
      if (RENDER) {
        RENDER.addSphere(p15880[0], p15880[1] + p15881 - 1, p15880[2], 110, 120, 110, {
          src: "default",
          shadows: true,
          vNoise: 0.36,
          xR: p15882,
          coat: p15883.cot,
          colr: p15883.col || vA700[p15882 % vA700.length]
        });
      }
    }
  }, {
    name: "Pine",
    height: [90, 120, 140],
    scales: [3, 3.2],
    rar: [5, 6, 7],
    gen: function (p15884, p15885, p15886, p15887) {
      if (RENDER) {
        var v12750 = p15884[1] + 40;
        var vLN308 = 30;
        for (var v12751 = p15885 >= 130 ? 5 : 4, vLN02288 = 0; vLN02288 < v12751; vLN02288++) {
          RENDER.addCone(p15884[0], v12750, p15884[2], vLN308 * 2, 40, vLN308 * 2, {
            src: "default",
            closC: true,
            xR: p15886,
            yR: UTILS.randFloat(-0.1, 0.1),
            zR: UTILS.randFloat(-0.1, 0.1),
            vNoise: 0.12,
            sides: 6,
            shadows: true,
            colr: p15887.col || vA700[p15886 % vA700.length]
          });
          vLN308 -= 5;
          v12750 += p15885 / v12751;
        }
      }
    }
  }, {
    name: "Tall Italian",
    height: [37],
    scales: [3, 3.2],
    rar: [1, 2, 3],
    gen: function (p15888, p15889, p15890, p15891) {
      if (RENDER) {
        RENDER.addSphere(p15888[0], p15888[1] + p15889 - 6, p15888[2], 39, 80, 39, {
          src: "default",
          shadows: true,
          vNoise: 0.3,
          xR: p15890,
          coat: p15891.cot,
          colr: p15891.col || vA700[p15890 % vA700.length]
        });
      }
    }
  }, {
    name: "Honey Oak",
    height: [100, 120],
    scales: [4, 5],
    rar: [0],
    gen: function (p15892, p15893, p15894, p15895) {
      if (RENDER) {
        RENDER.addSphere(p15892[0], p15892[1] + p15893 - 1, p15892[2], 70, 80, 70, {
          src: "default",
          shadows: true,
          vNoise: 0.35,
          xR: p15894,
          coat: p15895.cot,
          colr: p15895.col || "#616037"
        });
        RENDER.addCube(p15892[0] + 10, p15892[1] + p15893 / 1.5 + 5, p15892[2], 22, 3, 2, [1, 1, 1, 1, 1, 1], {
          src: "default",
          colr: "#665547",
          zR: 0.4,
          shadows: true,
          amb: 0.5
        });
        RENDER.addSphere(p15892[0] + 20, p15892[1] + p15893 / 1.5, p15892[2], 30, 28, 30, {
          src: "default",
          shadows: true,
          vNoise: 0.25,
          coat: p15895.cot,
          colr: p15895.col || "#616037"
        });
      }
    }
  }];
  this.addTREE = function (p15896, p15897) {
    var v12752 = Math.round(Math.abs((p15896[0] + p15896[2]) % 10));
    var v12753 = null;
    for (var vLN02289 = 0; vLN02289 < vA701.length; ++vLN02289) {
      if (vA701[vLN02289].rar.indexOf(v12752) >= 0) {
        v12753 = vA701[vLN02289];
        break;
      }
    }
    if (v12753) {
      var v12754 = v12753.height[v12752 % v12753.height.length] - v12752 * 2;
      var v12755 = v12753.scales[v12752 % v12753.scales.length];
      if (RENDER) {
        RENDER.addCylinder(p15896[0], p15896[1], p15896[2], v12755 * 1.5, v12754 + 20, v12755 * 1.5, {
          src: "default",
          sides: 4,
          open: true,
          colr: "#524435",
          shadows: true,
          amb: 0.5
        });
      }
      this.objects.push(new GameObject({
        x: p15896[0],
        z: p15896[2],
        y: p15896[1] + v12754 / 2,
        w: v12755 / 2,
        l: v12755 / 2,
        h: v12754 / 2,
        noAmb: true,
        uid: this.objects.length,
        penetrable: 1,
        noMinimap: true
      }));
      v12753.gen(p15896, v12754, v12752, p15897);
    }
  };
  this.addSTUMP = function (p15898) {
    var vLN804 = 80;
    var vLN416 = 4;
    if (RENDER) {
      RENDER.addCube(p15898[0], p15898[1], p15898[2], vLN416, vLN804, vLN416, [1, 1, 1, 0, 1, 1], {
        src: "default",
        colr: "#665547",
        shadows: true,
        amb: 0.5
      });
      RENDER.addCube(p15898[0], p15898[1] + 30, p15898[2] + 10, 2, 3, 22, [1, 1, 1, 1, 1, 1], {
        src: "default",
        colr: "#665547",
        yR: -0.5,
        shadows: true,
        amb: 0.5
      });
      RENDER.addCube(p15898[0] + 10, p15898[1] + 50, p15898[2], 22, 3, 2, [1, 1, 1, 1, 1, 1], {
        src: "default",
        colr: "#665547",
        zR: 0.4,
        shadows: true,
        amb: 0.5
      });
    }
    this.objects.push(new GameObject({
      x: p15898[0],
      z: p15898[2],
      y: p15898[1] + vLN804 / 2,
      w: vLN416 / 2,
      l: vLN416 / 2,
      h: vLN804 / 2,
      noAmb: true,
      uid: this.objects.length,
      penetrable: 1,
      noMinimap: true
    }));
  };
  this.addBUSH = function (p15899, p15900) {
    var v12756 = p15899[3];
    var v12757 = Math.round(Math.abs((p15899[0] + p15899[2]) % 10));
    var v12758 = v12756 == 2 ? 0.5 : 1;
    if (RENDER) {
      RENDER.addSphere(p15899[0], p15899[1] - v12758 * 6, p15899[2], v12758 * 29, v12758 * 21, v12758 * 28, {
        src: "default",
        colr: p15900.col || "#646639",
        vNoise: 0.3,
        coat: p15900.cot,
        xR: v12757,
        shadows: true
      });
    }
  };
  var vA702 = [{
    name: "Grass",
    scl: 1.2,
    h: [5, 6]
  }, {
    name: "Flower",
    scl: 0.3,
    h: [2, 2.3],
    gen: function (p15901, p15902, p15903, p15904) {
      RENDER.addPlane(p15901, p15902 + p15904 + 0.05, p15903, 1.2, 1.2, {
        type: 1,
        src: "default",
        mat: THREE.MeshBasicMaterial,
        shadowsR: true,
        vertexColors: true,
        colr: "#993d36"
      }, UTILS.randFloat(-Math.PI, Math.PI), 0.5, 0);
    }
  }];
  this.addGRASS = function (p15905, p15906) {
    if (RENDER) {
      for (var vLN02290 = 0; vLN02290 < 4; ++vLN02290) {
        var v12759 = vA702[UTILS.randInt(0, 1)];
        var v12760 = p15905[0] + UTILS.randInt(-15, 15);
        var v12761 = p15905[2] + UTILS.randInt(-15, 15);
        var v12762 = v12759.h[UTILS.randInt(0, v12759.h.length - 1)];
        RENDER.addPlane(v12760, p15905[1], v12761, v12759.scl, v12762, {
          type: 1,
          src: "default",
          mat: THREE.MeshBasicMaterial,
          side: THREE.DoubleSide,
          shadowsR: true,
          vertexColors: true,
          colr: p15906.col || "#4d5928"
        }, UTILS.randFloat(-Math.PI, Math.PI), Math.PI / 2, 0);
        if (v12759.gen) {
          v12759.gen(v12760, p15905[1], v12761, v12762);
        }
      }
    }
  };
  this.addLOOT = function (p15907) {
    var v12763 = Math.round(Math.abs((p15907[0] + p15907[2]) % 3));
    if (RENDER) {
      RENDER.addCube(p15907[0] + 6, p15907[1], p15907[2] + 15, 18, 1, 3, [1, 1, 1, 0, 1, 1], {
        src: "default",
        colr: "#665547",
        xR: 0.86,
        shadows: true,
        amb: 0.5
      });
    }
    if (v12763 == 0 || v12763 == 1) {
      this.addCylinder(p15907[0], p15907[1], p15907[2], 7, 7, 9, {
        src: "default",
        colr: "#9e2b2b",
        shadows: true
      });
    }
    if (v12763 == 2 || v12763 == 1) {
      this.addCylinder(p15907[0] - 7, p15907[1], p15907[2] + 12, 7, 7, 9, {
        src: "default",
        colr: "#2b769e",
        shadows: true
      });
    }
  };
  var vA703 = [{
    scl: 25,
    hei: 20,
    nois: 0.2,
    col: "#707070"
  }, {
    scl: 50,
    hei: 30,
    nois: 0.3,
    col: "#545454"
  }, {
    scl: 13,
    hei: 10,
    nois: 0.15,
    col: "#707070",
    noCol: true
  }, {
    scl: 10,
    hei: 10,
    nois: 0.1,
    col: "#545454",
    noCol: true
  }];
  this.addROCK = function (p15908, p15909) {
    var v12764 = p15908[1] - 7;
    var v12765 = Math.round(Math.abs((p15908[0] + p15908[2]) % 10));
    var v12766 = vA703[v12765 % vA703.length];
    if (RENDER) {
      RENDER.addSphere(p15908[0], v12764, p15908[2], v12766.scl, v12766.hei, v12766.scl, {
        src: "default",
        colr: v12766.col,
        vNoise: v12766.nois,
        noAmb: true,
        coat: p15909.cot,
        shadows: true
      });
    }
    if (!v12766.noCol) {
      this.objects.push(new GameObject({
        x: p15908[0],
        z: p15908[2],
        y: v12764 + v12766.hei / 2,
        w: v12766.scl / 2,
        l: v12766.scl / 2,
        h: v12766.hei / 2,
        uid: this.objects.length,
        noMinimap: true
      }));
    }
  };
  this.addTerrObj = function (p15910, p15911, p15912, p15913) {
    var vO409 = {
      col: null,
      cot: null
    };
    var v12767 = p15912.BIOME_INDEXES[p15910[3]];
    var v12768 = p15912.MAP_OBJS[p15911];
    if (v12768 && v12767) {
      if (v12768.biomeCoats && v12768.biomeCoats[v12767]) {
        vO409.cot = v12768.biomeCoats[v12767];
      }
      if (v12768.biomeCols && v12768.biomeCols[v12767]) {
        vO409.col = v12768.biomeCols[v12767][UTILS.randInt(0, v12768.biomeCols[v12767].length - 1)];
      }
    }
    this["add" + p15911](p15910, vO409, p15913);
  };
  this.addLadder = function (p15914, p15915, p15916, p15917, p15918, p15919) {
    p15919 = p15919 || {};
    p15919.src = p15919.src || "floor_0";
    p15919.texOffX = UTILS.limitMM(p15919.texOffX, 0, 1).round(2);
    p15919.texOffY = UTILS.limitMM(p15919.texOffY, 0, 1).round(2);
    p15919.texRot = UTILS.limitMM(p15919.texRot, 0, 360);
    p15919.texEncode = UTILS.limitMM(p15919.texEncode, 0, config.encodingTypes.length - 1);
    var v12769 = config.ladderScale;
    var v12770 = config.ladderScale;
    if (p15918 == 0 || p15918 == Math.PI) {
      v12770 = config.ladderWidth;
    } else {
      v12769 = config.ladderWidth;
    }
    v12693 = new GameObject({
      uid: this.objects.length,
      ladder: true,
      complexMesh: true,
      noShoot: true,
      s: p15919.sound || undefined,
      d: p15918,
      x: p15914 + config.ladderScale * Math.cos(p15918),
      z: p15916 + config.ladderScale * Math.sin(p15918),
      y: p15915 + p15917 / 2,
      w: v12769,
      l: v12770,
      h: p15917 / 2,
      noMinimap: true
    });
    this.objects.push(v12693);
    if (RENDER && !p15919.noVis) {
      p15919.vertexColors = true;
      p15919.shadows = true;
      p15919.amb = config.ambientVal;
      p15919.noEmisTex = true;
      p15919.transparent = p15919.fTrans || UTILS.isTransTex(p15919.src) || p15919.opacity != 1;
      if (UTILS.isTransTex(p15919.src)) {
        p15919.depthWrite = true;
        p15919.alphaTest = p15919.transparent ? 0.02 : 0;
      }
      var v12771 = p15919.colr;
      RENDER.addCube(v12693.x + config.ladderWidth * Math.sin(p15918), v12693.y - p15917 / 2, v12693.z + config.ladderWidth * Math.cos(p15918), config.ladderScale * 2, p15917 + 2, config.ladderScale * 2, [1, 1, 1, 1, 1, 1], p15919);
      p15919.colr = v12771;
      RENDER.addCube(v12693.x - config.ladderWidth * Math.sin(p15918), v12693.y - p15917 / 2, v12693.z - config.ladderWidth * Math.cos(p15918), config.ladderScale * 2, p15917 + 2, config.ladderScale * 2, [1, 1, 1, 1, 1, 1], p15919);
      var vLN610 = 6;
      for (var v12772 = Math.floor(p15917 / vLN610), vLN02291 = 0; vLN02291 < v12772; ++vLN02291) {
        p15919.colr = v12771;
        p15919.dark = 0.6 + vLN02291 / v12772 * 0.4;
        RENDER.addPlane(v12693.x, p15915 + vLN610 * (vLN02291 + 1) + UTILS.randFloat(-1, 1), v12693.z, config.ladderWidth, config.ladderScale, p15919, -p15918 + Math.PI / 2, Math.PI / 2, UTILS.randFloat(-0.1, 0.1));
      }
    }
  };
  this.addRopeLadder = function (p15920, p15921, p15922, p15923, p15924, p15925, p15926) {
    p15926 = p15926 || {};
    p15926.src = p15926.src || "floor_0";
    p15926.texOffX = UTILS.limitMM(p15926.texOffX || 0, 0, 1).round(2);
    p15926.texOffY = UTILS.limitMM(p15926.texOffY || 0, 0, 1).round(2);
    p15926.texRot = UTILS.limitMM(p15926.texRot, 0, 360);
    if (p15926.frames) {
      p15926.frames = UTILS.limitMM(parseInt(p15926.frames) || 0, 0, 100);
      p15926.frameT = UTILS.limitMM(parseFloat(p15926.frameT) || 0, 0, 10).round(1) * 100;
    }
    p15926.texEncode = UTILS.limitMM(p15926.texEncode, 0, config.encodingTypes.length - 1);
    v12693 = new GameObject({
      x: p15920,
      z: p15922,
      y: p15921 + p15925 / 2,
      w: Math.min(p15923, p15924) / 2,
      l: Math.min(p15923, p15924) / 2,
      h: p15925 / 2,
      uid: this.objects.length,
      s: p15926.sound || undefined,
      src: p15926.src,
      noVis: p15926.noVis,
      noAmb: p15926.noAmb,
      transparent: !!p15926.transparent || !!UTILS.isTransTex(p15926.src) || undefined,
      ropeLadder: true,
      complexMesh: true,
      noShoot: true,
      collT: "cylinder",
      noMinimap: true
    });
    this.objects.push(v12693);
    p15926.autoMatrix = !!p15926.health || !!p15926.canDest || p15926.interface;
    if (RENDER && !p15926.noVis) {
      p15926.transparent = p15926.fTrans || UTILS.isTransTex(p15926.src) || p15926.opacity != 1;
      if (UTILS.isTransTex(p15926.src)) {
        p15926.depthWrite = p15926.opacity == 1;
        p15926.alphaTest = p15926.transparent ? 0.02 : 0;
      }
      p15926.noEmisTex = true;
      p15926.vertexColors = true;
      p15926.scale = p15926.scale == null ? 1 : p15926.scale;
      p15926.shadows = !p15926.shadowsR && p15926.opacity == 1;
      RENDER.addCube(p15920, p15921, p15922, Math.min(p15923, p15924), p15925, Math.min(p15923, p15924), [1, 1, 1, 1, 1, 1], p15926);
    }
  };
  this.addRamp = function (p15927, p15928, p15929, p15930, p15931, p15932, p15933, p15934) {
    p15934 = p15934 || {};
    p15934.src = p15934.src || "grey_0";
    if (p15934.boost) {
      if (p15934.boost && !UTILS.isNumber(p15934.boost)) {
        p15934.boost = 1;
      }
      p15934.boost = parseFloat(p15934.boost) || 0;
      p15934.boost = UTILS.limit(p15934.boost, config.boostRange).round(2);
    }
    p15934.texOffX = UTILS.limitMM(p15934.texOffX || 0, 0, 1).round(2);
    p15934.texOffY = UTILS.limitMM(p15934.texOffY || 0, 0, 1).round(2);
    p15934.texRot = UTILS.limitMM(p15934.texRot, 0, 360);
    if (p15934.frames) {
      p15934.frames = UTILS.limitMM(parseInt(p15934.frames) || 0, 0, 100);
      p15934.frameT = UTILS.limitMM(parseFloat(p15934.frameT) || 0, 0, 10).round(1) * 100;
    }
    p15934.texEncode = UTILS.limitMM(p15934.texEncode, 0, config.encodingTypes.length - 1);
    var v12773 = p15933 != 0 && p15933 != Math.PI;
    var v12774 = (v12773 ? p15932 : p15930) / 2;
    var v12775 = Math.sqrt(p15931 * p15931 + p15932 * p15932);
    var v12776 = Math.asin(p15931 / v12775);
    p15934.w = p15930;
    p15934.h = p15931;
    p15934.l = p15932;
    p15934.rot = v12773;
    var v12777;
    var v12778 = -1;
    if (!p15934.noCol) {
      v12778 = p15934.uido == null ? this.objects.length : p15934.uido;
      v12777 = new GameObject({
        uid: v12778,
        buildInd: p15934.buildInd,
        breakSnd: p15934.breakSnd,
        dynamic: p15934.dynamic,
        type: 2,
        x: p15927,
        z: p15929,
        y: p15928 + p15931 / 2,
        w: p15930 / 2,
        l: p15932 / 2,
        h: p15931 / 2,
        d: p15933,
        s: p15934.sound || undefined,
        buildInd: p15934.buildInd,
        noShoot: true,
        complexMesh: true,
        boostDr: p15934.boost ? v12776 : null,
        boost: p15934.boost || null,
        noAICol: !!p15934.noAICol || undefined,
        ramp: {
          sX: p15927 - v12774 * Math.cos(p15933),
          sZ: p15929 - v12774 * Math.sin(p15933),
          eX: p15927 + v12774 * Math.cos(p15933),
          eZ: p15929 + v12774 * Math.sin(p15933)
        },
        noAmb: p15934.noAmb,
        enclose: p15934.enclose,
        noMinimap: p15934.noMinimap
      });
      this.objects.push(v12777);
    }
    if (RENDER && !p15934.noVis) {
      p15934.vertexColors = true;
      p15934.shadowsR = true;
      p15934.side = THREE.DoubleSide;
      p15934.noEmisTex = true;
      p15934.transparent = p15934.fTrans || UTILS.isTransTex(p15934.src) || p15934.opacity != 1;
      if (UTILS.isTransTex(p15934.src)) {
        p15934.depthWrite = true;
        p15934.alphaTest = p15934.transparent ? 0.02 : 0;
      }
      if (p15934.shaderBased) {
        RENDER.ShaderMesh.addBuild(p15927, p15928, p15929, p15930, p15931, p15932, {
          type: 2,
          src: p15934.src,
          model: p15934.model,
          uid: v12778,
          colr: p15934.colr || "#ff0000",
          emissive: null,
          opacity: 1,
          dir: p15933
        });
      } else {
        RENDER.addRamp(p15927, p15928, p15929, v12773 ? p15930 : p15932, p15931, (v12773 ? p15932 : p15930) / 2, p15933, p15934);
      }
    }
    return v12777;
  };
  this.addAIRedirection = function (p15935, p15936, p15937, p15938, p15939, p15940, p15941, p15942) {
    p15942 = p15942 || {};
    var v12779 = p15941 != 0 && p15941 != Math.PI;
    var v12780 = (v12779 ? p15940 : p15938) / 2;
    var v12781 = Math.sqrt(p15939 * p15939 + p15940 * p15940);
    var v12782 = Math.asin(p15939 / v12781);
    p15942.w = p15938;
    p15942.h = p15939;
    p15942.l = p15940;
    p15942.rot = v12779;
    var v12783 = new GameObject({
      uid: this.objects.length,
      x: p15935,
      z: p15937,
      y: p15936 + p15939 / 2,
      w: p15938 / 2,
      l: p15940 / 2,
      h: p15939 / 2,
      d: p15941,
      noShoot: true,
      complexMesh: true,
      boostDr: v12782,
      redirection: true,
      noMinimap: true
    });
    this.objects.push(v12783);
  };
  this.addMysteryBox = function (p15943, p15944, p15945, p15946, p15947, p15948, p15949, p15950) {
    p15950 = p15950 || {};
    p15950.src = p15950.src || "wall_0";
    var v12784 = new GameObject({
      active: false,
      x: p15943,
      z: p15945,
      y: p15944 + p15948,
      w: p15947,
      l: p15949,
      h: p15948,
      xR: p15946 ? p15946[0] : 0,
      yR: p15946 ? p15946[1] : 0,
      zR: p15946 ? p15946[2] : 0,
      uid: this.objects.length,
      src: p15950.src,
      transparent: undefined,
      complexMesh: true,
      tRadius: 7,
      mysteryBox: true,
      scoreP: p15950.scoreP || 1,
      noMinimap: true
    });
    p15944 += p15948;
    if (RENDER) {
      var v12785 = RENDER.loadMesh({
        src: "weaponbox_0",
        shadows: false,
        shadowsR: false,
        vertexColors: true,
        color: "#ffffff",
        noGroup: true,
        outlineMesh: 2
      }, p15943, p15944 - 1, p15945, p15946, 5, RENDER.scene);
      v12785.visible = false;
      v12784.meshRef = v12785;
      var v12786 = RENDER.loadMesh({
        src: "mysterybox_beam",
        shadows: false,
        shadowsR: false,
        vertexColors: true,
        color: "#AC69B9",
        mat: THREE.MeshBasicMaterial,
        noFog: true,
        transparent: true,
        depthWrite: false,
        alphaTest: 0.05,
        blending: 2,
        side: 2,
        noGroup: true
      }, p15943, p15944, p15945, p15946, 10, RENDER.scene);
      RENDER.scaleMesh(v12786, 10, 1000, 10);
      v12786.visible = false;
      v12784.beamMesh = v12786;
    }
    this.objects.push(v12784);
    this.mysteryBoxes.push(v12784.uid);
  };
  this.addPerkMachine = function (p15951, p15952, p15953, p15954, p15955, p15956, p15957, p15958) {
    p15958 = p15958 || {};
    p15958.src = p15958.src || "wall_0";
    p15958.perk = UTILS.limitMM(p15958.perk, 0, config.zombiePerks.length - 1);
    p15958.spawnChance = UTILS.limitMM(parseFloat(p15958.spawnChance) || 0, 0, 100).round(2);
    if (!p15958.spawnChance) {
      p15958.spawnChance = undefined;
    }
    if (p15958.health) {
      p15958.canDest = true;
    }
    if (p15958.complexColl && p15958.canDest) {
      p15958.complexColl = false;
    }
    p15958.autoMatrix = !!p15958.health || !!p15958.canDest || p15958.interface;
    var v12787 = new GameObject({
      x: p15951,
      z: p15953,
      y: p15952 + p15956,
      w: p15955,
      l: p15957,
      h: p15956,
      uid: this.objects.length,
      src: p15958.src,
      transparent: undefined,
      complexMesh: true,
      tRadius: 7,
      perkMachine: true,
      scoreP: p15958.scoreP || 1,
      perk: p15958.perk,
      isBorder: p15958.isBorder,
      health: p15958.health || undefined,
      canDest: p15958.canDest,
      breakSnd: p15958.breakSnd,
      startDest: p15958.canDest && p15958.startDest,
      spawnChance: p15958.spawnChance,
      respawnT: UTILS.isNumber(p15958.respawnT) && p15958.respawnT > 0 ? p15958.respawnT : undefined,
      respawnR: p15958.respawnR,
      trigger: p15958.trig,
      interface: p15958.interface,
      noMinimap: true
    });
    p15952 += p15956;
    if (RENDER) {
      var v12788 = RENDER.loadMesh({
        src: "perkmachine_0",
        texSrc: "perkmachine_0" + (p15958.perk ? "_" + p15958.perk : ""),
        shadows: false,
        shadowsR: false,
        vertexColors: true,
        color: "#ffffff",
        emissive: "#ffffff",
        glowText: true
      }, p15951, p15952, p15953, p15954, 5, RENDER.scene);
      v12787.meshRef = v12788;
    }
    this.objects.push(v12787);
    this.perkMachines.push(v12787.uid);
    this.addHelpers(p15958, v12787.uid);
  };
  this.addKrumMachine = function (p15959, p15960, p15961, p15962, p15963, p15964, p15965, p15966) {
    p15966 = p15966 || {};
    p15966.src = p15966.src || "wall_0";
    var v12789 = new GameObject({
      x: p15959,
      z: p15961,
      y: p15960 + p15964,
      w: p15963,
      l: p15965,
      h: p15964,
      xR: p15962 ? p15962[0] : 0,
      yR: p15962 ? p15962[1] : 0,
      zR: p15962 ? p15962[2] : 0,
      uid: this.objects.length,
      src: p15966.src,
      transparent: undefined,
      complexMesh: true,
      tRadius: 7,
      krumMachine: true,
      scoreP: p15966.scoreP || 1,
      isBorder: p15966.isBorder,
      noMinimap: true
    });
    p15960 += p15964;
    if (RENDER) {
      var v12790 = RENDER.loadMesh({
        src: "krummachine_0",
        shadows: false,
        shadowsR: false,
        vertexColors: true,
        color: "#ffffff",
        emissive: "#ffffff",
        glowText: true
      }, p15959, p15960, p15961, p15962, 7, RENDER.scene);
      v12789.meshRef = v12790;
    }
    this.objects.push(v12789);
    this.krumMachines.push(v12789);
  };
  this.addGate = function (p15967, p15968, p15969, p15970, p15971, p15972, p15973, p15974) {
    p15974 = p15974 || {};
    p15974.src = p15974.src || "wall_0";
    p15974.autoMatrix = true;
    p15974.penetrable = UTILS.limitMM(parseFloat(p15974.penetrable) || 0, 0, 1).round(2);
    p15974.texOffX = UTILS.limitMM(p15974.texOffX, 0, 1).round(2);
    p15974.texOffY = UTILS.limitMM(p15974.texOffY, 0, 1).round(2);
    p15974.texRot = UTILS.limitMM(p15974.texRot, 0, 360);
    if (p15974.frames) {
      p15974.frames = UTILS.limitMM(parseInt(p15974.frames) || 0, 0, 100);
      p15974.frameT = UTILS.limitMM(parseFloat(p15974.frameT) || 0, 0, 10).round(1) * 100;
    }
    p15974.texEncode = UTILS.limitMM(p15974.texEncode, 0, config.encodingTypes.length - 1);
    if (p15974.interface) {
      p15974.interface = UTILS.limitMM(p15974.interface, 0, config.interfaceIDMax);
    }
    if (p15974.interfaceT) {
      p15974.interfaceT = UTILS.limitMM(p15974.interfaceT, 0, config.interfaceIDMax);
    }
    if (p15974.interactMsg && UTILS.isString(p15974.interactMsg) && p15974.interactMsg != "") {
      if (p15974.interactMsg.length > 70) {
        p15974.interactMsg = undefined;
      }
      if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(p15974.interactMsg)) {
        p15974.interactMsg = undefined;
      }
    } else {
      p15974.interactMsg = undefined;
    }
    var v12791 = new GameObject({
      x: p15967,
      z: p15969,
      y: p15968 + p15972 / 2,
      w: p15970 / 2,
      l: p15971 / 2,
      h: p15972 / 2,
      uid: this.objects.length,
      src: p15974.src,
      s: p15974.sound || undefined,
      noVis: p15974.noVis,
      noAmb: p15974.noAmb,
      notWallJ: p15974.notWallJ,
      noGrapple: p15974.noGrapple,
      noShoot: !!p15974.noShoot || undefined,
      noAICol: !!p15974.noAICol || undefined,
      noImpulse: p15974.noImpulse,
      transparent: !!p15974.transparent || !!UTILS.isTransTex(p15974.src) || undefined,
      penetrable: p15974.penetrable > 0 ? p15974.penetrable : undefined,
      isBorder: p15974.isBorder,
      complexMesh: !!p15974.xR || !!p15974.yR || !!p15974.zR || !!UTILS.isTransTex(p15974.src) || undefined,
      tRadius: 7,
      gate: true,
      scoreP: p15974.scoreP,
      noMsg: p15974.noMsg,
      method: p15974.method || undefined,
      closeable: p15974.closeable,
      startClosed: p15974.startClosed && p15974.closeable,
      interface: p15974.interface,
      team: p15974.team,
      interactMsg: p15974.interactMsg,
      noMinimap: p15974.noMinimap
    });
    if (RENDER && !p15974.noVis) {
      p15974.transparent = p15974.fTrans || UTILS.isTransTex(p15974.src) || p15974.opacity != 1;
      if (UTILS.isTransTex(p15974.src)) {
        p15974.depthWrite = p15974.opacity == 1;
        p15974.alphaTest = p15974.transparent ? 0.02 : 0;
      }
      p15974.noEmisTex = true;
      p15974.vertexColors = true;
      p15974.scale = p15974.scale == null ? 1 : p15974.scale;
      p15974.shadows = !p15974.shadowsR && p15974.opacity == 1;
      var v12792 = RENDER.addCube(p15967, p15968, p15969, p15970, p15972, p15971, p15973, p15974);
      v12791.meshRef = v12792;
    }
    this.objects.push(v12791);
    this.gates.push(v12791);
    this.addHelpers(p15974, v12791.uid);
  };
  this.addBank = function (p15975, p15976, p15977, p15978, p15979, p15980, p15981, p15982) {
    p15982 = p15982 || {};
    p15982.src = p15982.src || "wall_0";
    p15982.autoMatrix = true;
    p15982.penetrable = UTILS.limitMM(parseFloat(p15982.penetrable) || 0, 0, 1).round(2);
    p15982.texOffX = UTILS.limitMM(p15982.texOffX, 0, 1).round(2);
    p15982.texOffY = UTILS.limitMM(p15982.texOffY, 0, 1).round(2);
    p15982.texRot = UTILS.limitMM(p15982.texRot, 0, 360);
    if (p15982.frames) {
      p15982.frames = UTILS.limitMM(parseInt(p15982.frames) || 0, 0, 100);
      p15982.frameT = UTILS.limitMM(parseFloat(p15982.frameT) || 0, 0, 10).round(1) * 100;
    }
    p15982.texEncode = UTILS.limitMM(p15982.texEncode, 0, config.encodingTypes.length - 1);
    if (p15982.interface) {
      p15982.interface = UTILS.limitMM(p15982.interface, 0, config.interfaceIDMax);
    }
    if (p15982.interfaceT) {
      p15982.interfaceT = UTILS.limitMM(p15982.interfaceT, 0, config.interfaceIDMax);
    }
    if (p15982.interactMsg && UTILS.isString(p15982.interactMsg) && p15982.interactMsg != "") {
      if (p15982.interactMsg.length > 70) {
        p15982.interactMsg = undefined;
      }
      if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(p15982.interactMsg)) {
        p15982.interactMsg = undefined;
      }
    } else {
      p15982.interactMsg = undefined;
    }
    var v12793 = new GameObject({
      x: p15975,
      z: p15977,
      y: p15976 + p15980 / 2,
      w: p15978 / 2,
      l: p15979 / 2,
      h: p15980 / 2,
      uid: this.objects.length,
      src: p15982.src,
      s: p15982.sound || undefined,
      noVis: p15982.noVis,
      noAmb: p15982.noAmb,
      notWallJ: p15982.notWallJ,
      noGrapple: p15982.noGrapple,
      noShoot: !!p15982.noShoot || undefined,
      noAICol: !!p15982.noAICol || undefined,
      noImpulse: p15982.noImpulse,
      transparent: !!p15982.transparent || !!UTILS.isTransTex(p15982.src) || undefined,
      penetrable: p15982.penetrable > 0 ? p15982.penetrable : undefined,
      isBorder: p15982.isBorder,
      complexMesh: !!p15982.xR || !!p15982.yR || !!p15982.zR || !!UTILS.isTransTex(p15982.src) || undefined,
      tRadius: 7,
      bank: true,
      interface: p15982.interface,
      withdraw: Math.abs(p15982.withdraw),
      deposit: Math.abs(p15982.deposit),
      team: p15982.team,
      interactMsg: p15982.interactMsg,
      noMinimap: p15982.noMinimap
    });
    if (RENDER && !p15982.noVis) {
      p15982.transparent = p15982.fTrans || UTILS.isTransTex(p15982.src) || p15982.opacity != 1;
      if (UTILS.isTransTex(p15982.src)) {
        p15982.depthWrite = p15982.opacity == 1;
        p15982.alphaTest = p15982.transparent ? 0.02 : 0;
      }
      p15982.noEmisTex = true;
      p15982.vertexColors = true;
      p15982.scale = p15982.scale == null ? 1 : p15982.scale;
      p15982.shadows = !p15982.shadowsR && p15982.opacity == 1;
      RENDER.addCube(p15975, p15976, p15977, p15978, p15980, p15979, p15981, p15982);
    }
    this.objects.push(v12793);
    this.banks.push(v12793);
    this.addHelpers(p15982, v12793.uid);
  };
  this.addHelpers = function (p15983, p15984) {
    if (!p15983.noCol) {
      if (p15983.interface) {
        this.interfaces.push(p15984);
      }
      if (p15983.eventN == "onTimer") {
        this.timerObjs.push(p15984);
      }
      if (p15983.eventN && p15983.eventN.includes("onPlayer")) {
        this.playerObjs.push(p15984);
      }
    }
  };
  this.addTrigger = function (p15985, p15986, p15987, p15988, p15989, p15990, p15991, p15992, p15993, p15994) {
    p15993 = p15993 || {};
    var v12794 = p15993.asset != null;
    if (v12794) {
      p15989 /= 2;
      p15990 /= 2;
      p15991 /= 2;
      p15993.src = "model";
      if (p15993.mSize) {
        p15993.mSize = UTILS.limitMM(p15993.mSize, 0.01, 100).round(2);
      }
      v12693 = p15699.getPrefabByName("CUSTOM_ASSET");
      if (!UTILS.isNumber(p15993.asset)) {
        p15993.asset += "";
      }
      if (!UTILS.isString(p15993.asset)) {
        p15993.asset = undefined;
      }
      var v12795 = (p15993.asset || "").includes("e");
      var v12796 = (p15993.asset || "").includes("n");
      var v12797 = (p15993.asset || "").includes("s");
      var v12798 = (p15993.asset || "").includes("a");
      var v12799 = (p15993.asset || "").includes("m");
      var v12800 = (p15993.asset || "").includes("r");
      var v12801 = (p15993.asset || "").includes("l");
      var v12802 = (p15993.asset || "").includes("p");
      var v12803 = (p15993.asset || "").includes("b");
      var v12804 = (p15993.asset || "").includes("g");
      var v12805 = (p15993.asset || "").includes("q");
      var v12806 = (p15993.asset || "").includes("f");
      p15993.alphaTest = UTILS.limitMM(parseInt(p15993.alphaTest) || 0, 0, 1).round(2);
      p15993.spin = UTILS.limitMM(p15993.spin, -20, 20);
      p15993.side = UTILS.limitMM(parseInt(p15993.side) || 0, 0, 2);
      p15993.spinAxis = UTILS.limitMM(p15993.spinAxis, 0, 1);
      if (p15993.spin != 0) {
        p15993.rAnim = (p15993.spin || 0) * config.diskSpin;
        p15993.rAnimA = p15993.spinAxis ? "x" : "y";
      }
      if (p15993.startAnim && UTILS.isString(p15993.startAnim) && p15993.startAnim != "") {
        if (p15993.startAnim.length > 32) {
          p15993.startAnim = "";
        }
        if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(p15993.startAnim)) {
          p15993.startAnim = "";
        }
      } else {
        p15993.startAnim = "";
      }
    }
    p15993.src = p15993.src || "wall_0";
    p15993.texOffX = UTILS.limitMM(p15993.texOffX, 0, 1).round(2);
    p15993.texOffY = UTILS.limitMM(p15993.texOffY, 0, 1).round(2);
    p15993.texRot = UTILS.limitMM(p15993.texRot, 0, 360);
    p15993.chance = UTILS.limitMM(p15993.chance, 0, 100);
    p15993.spawnChance = UTILS.limitMM(parseFloat(p15993.spawnChance) || 0, 0, 100).round(2);
    if (!p15993.spawnChance) {
      p15993.spawnChance = undefined;
    }
    p15993.constE = UTILS.limitMM(p15993.constE, 0, 10000);
    p15993.actionCost = UTILS.limitMM(p15993.actionCost, 0, 10000);
    if (p15993.frames) {
      p15993.frames = UTILS.limitMM(parseInt(p15993.frames) || 0, 0, 100);
      p15993.frameT = UTILS.limitMM(parseFloat(p15993.frameT) || 0, 0, 10).round(1) * 100;
    }
    p15993.hbh = UTILS.limitMM(p15993.hbh, 0.1, 10);
    p15993.hbw = UTILS.limitMM(p15993.hbw, 0.1, 10);
    p15993.texEncode = UTILS.limitMM(p15993.texEncode, 0, config.encodingTypes.length - 1);
    if (p15993.interface) {
      p15993.interface = UTILS.limitMM(p15993.interface, 0, config.interfaceIDMax);
    }
    if (p15993.interfaceT) {
      p15993.interfaceT = UTILS.limitMM(p15993.interfaceT, 0, config.interfaceIDMax);
    }
    p15993.autoMatrix = true;
    if (p15993.eventN && p15993.eventN.includes("onAI")) {
      p15993.eventN = null;
    }
    if (p15993.actionCost && p15993.eventN != "onInteractKey" && !p15993.actionMethod) {
      p15993.actionCost = 0;
    }
    if (p15993.eventN && p15993.eventN == "onInteractKey") {
      p15993.tRadius = 7;
    }
    if (p15993.health) {
      p15993.canDest = true;
    }
    if (p15993.interactMsg && UTILS.isString(p15993.interactMsg) && p15993.interactMsg != "") {
      if (p15993.interactMsg.length > 70) {
        p15993.interactMsg = undefined;
      }
      if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(p15993.interactMsg)) {
        p15993.interactMsg = undefined;
      }
    } else {
      p15993.interactMsg = undefined;
    }
    var vA704 = [];
    if (p15993.actions) {
      for (var vLN02292 = 0; vLN02292 < p15993.actions.length; vLN02292++) {
        if (p15993.actions[vLN02292]) {
          var v12807 = parseInt(p15993.actions[vLN02292].tc) || 0;
          var v12808 = parseInt(p15993.actions[vLN02292].tc2) || 0;
          var v12809 = p15993.actions[vLN02292].tct;
          var v12810 = p15993.actions[vLN02292].tcc;
          var v12811 = parseInt(p15993.actions[vLN02292].tce) || 0;
          var v12812 = parseInt(p15993.actions[vLN02292].ta) || 0;
          var v12813 = parseInt(p15993.actions[vLN02292].esa || p15993.actions[vLN02292].es) || 0;
          var v12814 = p15993.actions[vLN02292].esa != null;
          var v12815 = parseFloat(p15993.actions[vLN02292].ev) || 1;
          var v12816 = parseFloat(p15993.actions[vLN02292].er) || 1;
          var v12817 = parseInt(p15993.actions[vLN02292].ef) || 0;
          var v12818 = parseFloat(p15993.actions[vLN02292].tad) || 0;
          var v12819 = parseInt(p15993.actions[vLN02292].cd) || 0;
          var vO410 = {};
          if (!p15994.conditions[v12819]) {
            v12819 = 0;
          }
          var v12820 = p15994.conditions[v12819];
          if (v12820 && v12820.vals) {
            var v12821;
            for (var vLN02293 = 0; vLN02293 < v12820.vals.length; vLN02293++) {
              v12821 = v12820.vals[vLN02293].def;
              if (p15993.actions[vLN02292]["cv" + vLN02293] == null) {
                vO410[vLN02293] = v12821;
                continue;
              }
              if (v12820.vals[vLN02293].bool) {
                v12821 = !!p15993.actions[vLN02292]["cv" + vLN02293];
              } else if (v12820.vals[vLN02293].input) {
                p15993.actions[vLN02292]["cv" + vLN02293] = p15993.actions[vLN02292]["cv" + vLN02293] + "";
                v12821 = UTILS.isString(p15993.actions[vLN02292]["cv" + vLN02293]) ? (p15993.actions[vLN02292]["cv" + vLN02293] || "").toString().replace(/[^a-z0-9_]+/gmi, "").substring(0, v12820.vals[vLN02293].len) : v12820.vals[vLN02293].def;
              } else if (v12820.vals[vLN02293].select) {
                v12821 = UTILS.limitMM(parseInt(p15993.actions[vLN02292]["cv" + vLN02293]) || v12821, 0, v12820.vals[vLN02293].select.length - 1);
              } else if (UTILS.isNumber(p15993.actions[vLN02292]["cv" + vLN02293])) {
                v12821 = UTILS.limitMM(parseFloat(p15993.actions[vLN02292]["cv" + vLN02293]) || v12821, v12820.vals[vLN02293].min, v12820.vals[vLN02293].max);
              } else {
                v12821 = v12820.vals[vLN02293].def;
              }
              vO410[vLN02293] = v12821;
            }
          }
          v12813 = v12814 ? v12813 : config.emitterSounds[v12813] ? config.emitterSounds[v12813] : config.emitterSounds[0];
          v12815 = UTILS.limitMM(v12815, config.emitterVolMin, config.emitterVolMax);
          v12816 = UTILS.limitMM(v12816, config.emitterRateMin, config.emitterRateMax);
          v12817 = UTILS.limitMM(v12817, 0, 2);
          v12818 = UTILS.limitMM(v12818, 0, 60).round(1);
          if (v12809) {
            if (v12809 && UTILS.isString(v12809) && v12809 != "") {
              if (v12809.length > 70) {
                v12809 = undefined;
              }
              if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(v12809)) {
                v12809 = undefined;
              }
            } else {
              v12809 = undefined;
            }
          } else {
            v12809 = undefined;
          }
          if ((v12812 == 37 || v12812 == 38) && v12809 != null) {
            v12809 = v12809.toString().replace(/[^a-z0-9_]+/gmi, "").substring(0, 10);
          }
          v12810 = v12810 && UTILS.isString(v12810) ? v12810.toString().replace(/[^a-z0-9_]+/gmi, "").substring(0, 10) : undefined;
          var vO411 = {};
          if (v12807) {
            vO411.trigConst = v12807;
          }
          if (v12808) {
            vO411.trigConst2 = v12808;
          }
          if (v12809 != null) {
            vO411.trigConstTx = v12809;
          }
          if (v12810 != null) {
            vO411.trigConstC = v12810;
          }
          if (v12811) {
            vO411.trigConstT = v12811;
          }
          if (v12812) {
            vO411.trigAct = v12812;
          }
          if (v12818) {
            vO411.trigDelay = v12818;
          }
          if (v12819) {
            vO411.trigCond = [v12819, vO410[0], vO410[1], vO410[2]];
          }
          if (v12813 != "nuke_0" || v12815 != 1 || v12816 != 1 || v12817 != 0 || !!v12814) {
            vO411.triggerSound = [v12813, v12815, v12816, v12817, v12814];
          }
          vA704.push(vO411);
        }
      }
    }
    var v12822 = new GameObject({
      aoM: v12794 ? 0 : undefined,
      x: p15985,
      z: p15987,
      y: p15986 + (v12794 ? p15991 : p15991 / 2) * (p15993.hbh || 1),
      w: (v12794 ? p15989 : p15989 / 2) * (p15993.hbw || 1),
      l: (v12794 ? p15990 : p15990 / 2) * (p15993.hbw || 1),
      h: (v12794 ? p15991 : p15991 / 2) * (p15993.hbh || 1),
      uid: this.objects.length,
      src: p15993.src,
      s: p15993.sound || undefined,
      noVis: p15993.noVis,
      noAmb: p15993.noAmb,
      notWallJ: p15993.notWallJ,
      noGrapple: p15993.noGrapple,
      noImpulse: p15993.noImpulse,
      health: p15993.health || undefined,
      canDest: p15993.canDest,
      startDest: p15993.canDest && p15993.startDest,
      spawnChance: p15993.spawnChance,
      selfDestruct: p15993.selfDestruct && p15993.canDest,
      respawnT: UTILS.isNumber(p15993.respawnT) && p15993.respawnT > 0 ? p15993.respawnT : undefined,
      respawnR: p15993.respawnR,
      transparent: !!p15993.transparent || p15993.src == UTILS.isTransTex(p15993.src) || undefined,
      complexMesh: !!v12794 || !!p15993.xR || !!p15993.yR || !!p15993.zR || !!UTILS.isTransTex(p15993.src) || undefined,
      constE: p15993.constE || undefined,
      chance: p15993.chance || undefined,
      eventN: p15993.eventN,
      actions: vA704,
      actionCost: p15993.actionCost || undefined,
      actionMethod: p15993.actionMethod || undefined,
      interface: p15993.interface,
      interfaceT: p15993.interfaceT,
      team: p15993.team,
      noShoot: p15993.eventN == "onEnterObject" || p15993.eventN == "onExitObject" || !!p15993.noShoot || undefined,
      noAICol: !!p15993.noAICol || undefined,
      singleUse: p15993.singleUse,
      singleUseP: p15993.singleUseP,
      tRadius: p15993.tRadius,
      interactMsg: p15993.interactMsg,
      noPCol: p15993.noPCol,
      asset: v12794 ? p15993.asset : undefined,
      hasAnim: v12794 ? !!v12804 || !!v12805 || !!v12806 || undefined : undefined,
      noMinimap: p15993.noMinimap
    });
    if (v12794 && v12693 && v12693.transparent) {
      p15986 += UTILS.randFloat(-0.01, 0.01);
    }
    if (RENDER && !p15993.noVis) {
      if (v12794) {
        var v12823 = (p15993.asset || "").replace(/[^\d]/g, "");
        var v12825 = RENDER[v12804 || v12805 || v12806 ? "loadAnimMesh" : "loadMesh"]({
          isMdl: true,
          fileExt: v12805 ? "glb" : v12804 ? "gltf" : v12806 ? "fbx" : null,
          src: v12823 + "/" + p15993.src,
          texSrc: p15993.texSrc,
          emissive: v12795 ? "#ffffff" : null,
          opacity: p15993.opacity,
          transparent: p15993.fTrans || p15993.transparent || p15993.opacity != 1,
          shadows: p15993.cast && !p15993.receive,
          shadowsR: p15993.receive,
          vertexColors: true,
          color: p15993.colr || "#ffffff",
          noGroup: !!p15993.health || !!p15993.canDest,
          backup: [p15989, p15990, p15991],
          normal: v12796,
          spec: v12797,
          alphaTest: p15993.alphaTest || (v12798 ? 0.02 : 0),
          asset: v12823,
          tFilter: p15993.noSmooth ? THREE.NearestFilter : THREE.LinearFilter,
          rAnim: p15993.rAnim,
          rAnimA: p15993.rAnimA,
          animS: p15993.animS,
          startAnim: p15993.startAnim,
          metalness: v12799 ? 1 : 0,
          roughness: v12800 ? 1 : 0,
          lightM: v12801 ? 1 : 0,
          uv2: !!v12801 || undefined,
          displacement: v12802 ? 1 : 0,
          bump: v12803 ? 1 : 0,
          canDest: p15993.canDest,
          side: p15993.side,
          noFog: p15993.noFog,
          offsetH: v12804 || v12805 || v12806 ? 0 : p15991
        }, p15985, p15986, p15987, p15988, p15993.mSize || 1, RENDER.scene, !p15993.spin && !p15993.health && !p15993.canDest && !p15993.texSrc);
        if ((p15993.health || p15993.canDest || v12804 || v12805 || v12806) && !p15993.noCol) {
          v12822.meshRef = v12825;
        }
      } else {
        delete p15993.asset;
        if (p15993.assetTexture) {
          p15993.asset = true;
        }
        p15993.transparent = p15993.fTrans || UTILS.isTransTex(p15993.src) || p15993.opacity != 1;
        if (UTILS.isTransTex(p15993.src)) {
          p15993.depthWrite = p15993.opacity == 1;
          p15993.alphaTest = p15993.transparent ? 0.02 : 0;
        }
        p15993.noEmisTex = true;
        p15993.vertexColors = true;
        p15993.scale = p15993.scale == null ? 1 : p15993.scale;
        p15993.shadows = !p15993.shadowsR && p15993.opacity == 1;
        var v12825 = RENDER.addCube(p15985, p15986, p15987, p15989, p15991, p15990, p15992, p15993);
        if ((p15993.health || p15993.canDest) && !p15993.noCol) {
          v12822.meshRef = v12825;
        }
      }
    }
    this.objects.push(v12822);
    this.addHelpers(p15993, v12822.uid);
  };
  this.addMapAnchor = function (p15995, p15996, p15997, p15998) {
    this.mapAnchors.push({
      x: p15995,
      y: p15996,
      z: p15997,
      type: parseInt(p15998) || 0
    });
  };
  this.addSpray = function (p15999, p16000, p16001, p16002, p16003, p16004, p16005, p16006, p16007, p16008) {
    p16004 = p16004 || {};
    p16004.sprayIndex = parseInt(p16004.sprayIndex) || 2482;
    var v12826 = p16008.skins[p16004.sprayIndex];
    if (!v12826 || v12826.type != itemTypes.SPRAY) {
      v12826 = p16008.skins[2482];
    }
    p16004.src = "sprays/" + v12826.id;
    p16000 += UTILS.randInt(0, 100) * 0.00001;
    if (RENDER && !p16004.noVis) {
      p16004.side = THREE.DoubleSide;
      p16004.vertexColors = true;
      p16004.shadowsR = true;
      p16004.scale = 0;
      p16004.local = v12826.local;
      p16004.depthWrite = false;
      p16004.opacity = (v12826.opacity || 1) * p16004.opacity;
      p16004.transparent = true;
      p16004.frames = v12826.frames;
      p16004.frameT = v12826.frameT;
      p16004.movT = v12826.movT;
      p16004.movD = v12826.movD;
      p16004.rgb = v12826.rgb;
      p16004.rgbS = v12826.rgbS;
      p16004.rgbT = v12826.rgbT;
      p16004.sameGlow = v12826.sameGlow;
      p16004.glowText = v12826.glow || v12826.sameGlow;
      p16004.emissive = v12826.glow || v12826.sameGlow ? "#ffffff" : null;
      p16004.pulsT = v12826.pulsT;
      p16004.rAnim = v12826.rAnim;
      p16004.rAnimA = v12826.rAnimA;
      var vA705 = [p15999, p16000, p16001, p16002, p16003, p16004, p16005, p16006, p16007];
      var v12827 = RENDER.addFixedPlane(...vA705);
    }
  };
  this.addSpinner = function (p16009, p16010, p16011, p16012, p16013, p16014, p16015, p16016) {
    p16016 = p16016 || {};
    p16016.src = p16016.src || "wall_0";
    p16016.wheel = UTILS.limitMM(p16016.wheel, 0, 2);
    var v12828 = p16013 / 2;
    var v12829 = new GameObject({
      x: p16009,
      z: p16011,
      y: p16010,
      w: v12828 / 2,
      l: v12828 / 2,
      h: v12828 / 2,
      d: p16015,
      uid: this.spinners.length,
      noVis: p16016.noVis,
      noAmb: p16016.noAmb,
      complexMesh: !!p16016.xR || !!p16016.yR || !!p16016.zR || !!UTILS.isTransTex(p16016.src) || undefined,
      tRadius: p16016.tRadius,
      wheel: p16016.wheel,
      noMinimap: true
    });
    p16010 += v12828;
    if (RENDER && !p16016.noVis) {
      p16016.transparent = true;
      p16016.vertexColors = true;
      p16016.scale = p16016.scale == null ? 1 : p16016.scale;
      p16016.shadows = !p16016.shadowsR && p16016.opacity == 1;
      p16016.noGroup = true;
      var v12830 = RENDER.addSpinner(p16009, p16010, p16011, v12828, p16015 * Math.PI / 4, p16016);
      v12829.meshRef = v12830;
    }
    this.spinners.push(v12829);
  };
  this.addEmitter = function (p16017, p16018, p16019, p16020) {
    p16020 = p16020 || {};
    if (p15698) {
      p16020.snd = p16020.assetSnd ? p16020.snd : config.emitterSounds[p16020.snd] ? config.emitterSounds[p16020.snd] : config.emitterSounds[0];
      p16020.vol = UTILS.limitMM(p16020.vol, config.emitterVolMin, config.emitterVolMax);
      p16020.rate = UTILS.limitMM(p16020.rate, config.emitterRateMin, config.emitterRateMax);
      p16020.roll = UTILS.limitMM(p16020.roll, config.emitterRollMin, config.emitterRollMax);
      p16020.dist = UTILS.limitMM(p16020.dist, config.emitterDistMin, config.emitterDistMax);
      p16020.distM = UTILS.limitMM(p16020.distM, 0, 2);
      p15698.play3DL(p16020.snd, p16017, p16018, p16019, p16020.vol, p16020.rate, p16020.dist, p16020.roll, !!p16020.assetSnd, p16020.distM);
    }
  };
  this.addPointLight = function (p16021, p16022, p16023, p16024) {
    p16024 = p16024 || {};
    p16024.intensity = UTILS.limitMM(p16024.intensity, 0, 15);
    p16024.distance = UTILS.limitMM(p16024.distance, 0, 1000);
    p16024.decay = UTILS.limitMM(p16024.decay, 0.1, 2);
    p16022 += 5 / 2;
    if (!RENDER || !!RENDER.mapDet) {
      if (RENDER) {
        p16024.noEmisTex = true;
        RENDER.addPointLight(p16021, p16022, p16023, p16024);
      }
    }
  };
  this.addDirectionalLight = function (p16025, p16026, p16027, p16028, p16029, p16030, p16031) {
    p16031 = p16031 || {};
    p16031.intensity = UTILS.limitMM(p16031.intensity, 0, 15);
    p16026 += 2;
    if (!RENDER || !!RENDER.mapDet) {
      if (RENDER) {
        p16031.noEmisTex = true;
        RENDER.addDirectionalLight(p16025, p16026, p16027, p16028, p16029, p16030, p16031);
      }
    }
  };
  this.addSpotLight = function (p16032, p16033, p16034, p16035, p16036, p16037, p16038) {
    p16038 = p16038 || {};
    p16038.intensity = UTILS.limitMM(p16038.intensity, 0, 15);
    p16038.distance = UTILS.limitMM(p16038.distance, 0, 1000);
    p16038.decay = UTILS.limitMM(p16038.decay, 0.1, 2);
    p16038.angle = UTILS.limitMM(p16038.angle, 1, 90);
    p16038.penumbra = UTILS.limitMM(p16038.penumbra, 0, 1);
    p16033 += 2;
    if (!RENDER || !!RENDER.mapDet) {
      if (RENDER) {
        p16038.noEmisTex = true;
        RENDER.addSpotLight(p16032, p16033, p16034, p16035, p16036, p16037, p16038);
      }
    }
  };
  this.addRectAreaLight = function (p16039, p16040, p16041, p16042, p16043, p16044, p16045, p16046, p16047) {
    p16044 = p16044 || {};
    p16044.intensity = UTILS.limitMM(p16044.intensity, 0, 15);
    p16040 += p16043;
    if (!RENDER || !!RENDER.mapDet) {
      if (RENDER) {
        p16044.noEmisTex = true;
        RENDER.addRectAreaLight(p16039, p16040, p16041, p16042, p16043, p16044, p16045, p16046 || 0, p16047);
      }
    }
  };
  this.addLightCone = function (p16048, p16049, p16050, p16051, p16052, p16053, p16054) {
    p16054 = p16054 || {};
    p16054.src = p16054.src || "lightcone_0";
    p16054.texEncode = UTILS.limitMM(p16054.texEncode, 0, config.encodingTypes.length - 1);
    p16054.thetaL = UTILS.limitMM(parseFloat(p16054.thetaL) || 0, 0.1, 360).round(2);
    p16054.sides = UTILS.limitMM(p16054.sides, 3, 64);
    if (RENDER && !p16054.noVis) {
      p16054.noEmisTex = true;
      p16054.depthWrite = false;
      p16054.scale = p16054.scale == null ? 1 : p16054.scale;
      p16054.shadows = false;
      p16054.side = THREE.DoubleSide;
      p16054.blending = THREE.AdditiveBlending;
      p16054.mat = THREE.MeshBasicMaterial;
      p16054.vertexColors = true;
      RENDER.addCone(p16048, p16049, p16050, p16051, p16053, p16052, p16054);
    }
  };
  this.addLightBar = function (p16055, p16056, p16057, p16058, p16059, p16060, p16061, p16062, p16063) {
    p16060 = p16060 || {};
    p16060.src = p16060.src || "lightcone_1";
    p16060.texEncode = UTILS.limitMM(p16060.texEncode, 0, config.encodingTypes.length - 1);
    if (RENDER && !p16060.noVis) {
      p16060.noEmisTex = true;
      p16060.depthWrite = false;
      p16060.shadows = false;
      p16060.transparent = true;
      p16060.side = THREE.DoubleSide;
      p16060.vertexColors = true;
      p16060.blending = THREE.AdditiveBlending;
      p16060.mat = THREE.MeshBasicMaterial;
      p16060.vertexColors = true;
      var v12831;
      if (p16060.mimicSprite) {
        p16060.color = p16060.colr || "#FFFFFF";
        p16060.mat = THREE.SpriteMaterial;
        v12831 = RENDER.addSprite(p16055, p16056, p16057, p16058, p16059, p16060);
      } else {
        v12831 = RENDER.addFixedPlane(p16055, p16056, p16057, p16058, p16059, p16060, p16061, p16062, p16063);
      }
    }
  };
  this.addCylinder = function (p16064, p16065, p16066, p16067, p16068, p16069, p16070) {
    p16070 = p16070 || {};
    p16070.src = p16070.src || "wall_0";
    p16070.penetrable = UTILS.limitMM(parseFloat(p16070.penetrable) || 0, 0, 1).round(2);
    p16070.spin = UTILS.limitMM(p16070.spin, -20, 20);
    p16070.sides = UTILS.limitMM(p16070.sides, 3, 64);
    p16070.rTop = UTILS.limitMM(parseFloat(p16070.rTop) || 0, 0, 1).round(2);
    p16070.rBot = UTILS.limitMM(parseFloat(p16070.rBot) || 0, 0, 1).round(2);
    p16070.thetaS = UTILS.limitMM(parseFloat(p16070.thetaS) || 0, 0, 360).round(2);
    p16070.thetaL = UTILS.limitMM(parseFloat(p16070.thetaL) || 0, 0.1, 360).round(2);
    p16070.texOffX = UTILS.limitMM(p16070.texOffX || 0, 0, 1).round(2);
    p16070.texOffY = UTILS.limitMM(p16070.texOffY || 0, 0, 1).round(2);
    p16070.texRot = UTILS.limitMM(p16070.texRot || 0, 0, 360);
    if (p16070.frames) {
      p16070.frames = UTILS.limitMM(parseInt(p16070.frames) || 0, 0, 100);
      p16070.frameT = UTILS.limitMM(parseFloat(p16070.frameT) || 0, 0, 10).round(1) * 100;
    }
    p16070.texEncode = UTILS.limitMM(p16070.texEncode, 0, config.encodingTypes.length - 1);
    p16070.spawnChance = UTILS.limitMM(parseFloat(p16070.spawnChance) || 0, 0, 100).round(2);
    if (!p16070.spawnChance) {
      p16070.spawnChance = undefined;
    }
    if (p16070.health) {
      p16070.canDest = true;
    }
    if (p16070.complexColl && p16070.canDest) {
      p16070.complexColl = false;
    }
    if (!p16070.noCol) {
      var v12832 = new GameObject({
        x: p16064,
        z: p16066,
        y: p16065 + p16069 / 2,
        w: Math.min(p16067, p16068) / 2,
        l: Math.min(p16067, p16068) / 2,
        h: p16069 / 2,
        uid: this.objects.length,
        src: p16070.src,
        noVis: p16070.noVis,
        transparent: !!p16070.transparent || !!UTILS.isTransTex(p16070.src) || undefined,
        complexMesh: true,
        collT: "cylinder",
        spin: p16070.spin,
        noGrapple: p16070.noGrapple,
        noShoot: !!p16070.noShoot || undefined,
        noAICol: !!p16070.noAICol || undefined,
        noImpulse: p16070.noImpulse,
        health: p16070.health || undefined,
        canDest: p16070.canDest,
        penetrable: p16070.penetrable > 0 ? p16070.penetrable : undefined,
        startDest: p16070.canDest && p16070.startDest,
        spawnChance: p16070.spawnChance,
        respawnT: UTILS.isNumber(p16070.respawnT) && p16070.respawnT > 0 ? p16070.respawnT : undefined,
        respawnR: p16070.respawnR,
        interface: p16070.interface,
        complexColl: !!p16070.complexColl || undefined,
        noMinimap: p16070.noMinimap
      });
      this.objects.push(v12832);
      this.addHelpers(p16070, this.objects.length - 1);
    }
    p16070.autoMatrix = !!p16070.health || !!p16070.canDest || p16070.interface;
    if (RENDER && !p16070.noVis) {
      p16070.transparent = p16070.fTrans || UTILS.isTransTex(p16070.src) || p16070.opacity != 1;
      if (UTILS.isTransTex(p16070.src)) {
        p16070.depthWrite = p16070.opacity == 1;
        p16070.alphaTest = p16070.transparent ? 0.02 : 0;
      }
      if (p16070.open) {
        p16070.rside = THREE.DoubleSide;
      }
      p16070.noEmisTex = true;
      p16070.vertexColors = true;
      p16070.scale = p16070.scale == null ? 0 : p16070.scale;
      p16070.shadows = !p16070.shadowsR && p16070.opacity == 1;
      p16070.rAnim = (p16070.spin || 0) * config.diskSpin;
      p16070.rAnimA = "y";
      if (p16070.spin) {
        p16070.noGroup = true;
      }
      var v12833 = RENDER.addCylinder(p16064, p16065, p16066, p16067, p16069, p16068, p16070);
      if ((p16070.health || p16070.canDest) && !p16070.noCol) {
        this.objects[this.objects.length - 1].meshRef = v12833;
      }
    }
  };
  this.addServerNode = function (p16071, p16072, p16073, p16074, p16075, p16076, p16077) {
    p16077 = p16077 || {};
    p16077.spread = UTILS.limitMM(p16077.spread, 0, 50);
    p16077.spawnChance = UTILS.limitMM(parseFloat(p16077.spawnChance) || 0, 0, 100).round(2);
    if (!p16077.spawnChance) {
      p16077.spawnChance = undefined;
    }
    if (p16077.health) {
      p16077.canDest = true;
    }
    if (p16077.tag) {
      if (p16077.tag && UTILS.isString(p16077.tag) && p16077.tag != "") {
        if (p16077.tag.length > 70) {
          p16077.tag = undefined;
        }
        if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(p16077.tag)) {
          p16077.tag = undefined;
        }
      } else {
        p16077.tag = undefined;
      }
    } else {
      p16077.tag = undefined;
    }
    let v12834 = new GameObject({
      x: p16071,
      z: p16073,
      y: p16072 + p16076 / 2,
      w: p16074 / 2,
      l: p16075 / 2,
      h: p16076 / 2,
      noShoot: true,
      complexMesh: true,
      uid: this.objects.length,
      health: p16077.health || undefined,
      canDest: p16077.canDest,
      startDest: p16077.canDest && p16077.startDest,
      spawnChance: p16077.spawnChance,
      respawnT: UTILS.isNumber(p16077.respawnT) && p16077.respawnT > 0 ? p16077.respawnT : undefined,
      respawnR: p16077.respawnR,
      interface: p16077.interface,
      noAICol: true,
      spread: p16077.spread,
      tag: p16077.tag,
      serverNode: true,
      noMinimap: true
    });
    this.objects.push(v12834);
    this.serverNodes.push(v12834);
    this.addHelpers(p16077, v12834.uid);
  };
  this.addBlock = function (p16078, p16079, p16080, p16081, p16082, p16083, p16084, p16085) {
    p16085 = p16085 || {};
    var v12835 = -1;
    var v12836 = null;
    p16085.src = p16085.src || "wall_0";
    p16085.penetrable = UTILS.limitMM(parseFloat(p16085.penetrable) || 0, 0, 1).round(2);
    p16085.texOffX = UTILS.limitMM(p16085.texOffX || 0, 0, 1).round(2);
    p16085.texOffY = UTILS.limitMM(p16085.texOffY || 0, 0, 1).round(2);
    p16085.texRot = UTILS.limitMM(p16085.texRot, 0, 360);
    if (p16085.frames) {
      p16085.frames = UTILS.limitMM(parseInt(p16085.frames) || 0, 0, 100);
      p16085.frameT = UTILS.limitMM(parseFloat(p16085.frameT) || 0, 0, 10).round(1) * 100;
    }
    p16085.texEncode = UTILS.limitMM(p16085.texEncode, 0, config.encodingTypes.length - 1);
    p16085.spawnChance = UTILS.limitMM(parseFloat(p16085.spawnChance) || 0, 0, 100).round(2);
    if (!p16085.spawnChance) {
      p16085.spawnChance = undefined;
    }
    if (p16085.health) {
      p16085.canDest = true;
    }
    if (p16085.complexColl && p16085.canDest) {
      p16085.complexColl = false;
    }
    if (!p16085.noCol) {
      v12835 = p16085.uido == null ? this.objects.length : p16085.uido;
      v12836 = new GameObject({
        x: p16078,
        z: p16080,
        y: p16079 + p16083 / 2,
        w: p16081 / 2,
        l: p16082 / 2,
        h: p16083 / 2,
        uid: v12835,
        buildInd: p16085.buildInd,
        s: p16085.sound || undefined,
        src: p16085.src,
        noVis: p16085.noVis,
        noAmb: p16085.noAmb,
        health: p16085.health || undefined,
        notWallJ: p16085.notWallJ,
        noGrapple: p16085.noGrapple,
        noShoot: !!p16085.noShoot || undefined,
        noAICol: !!p16085.noAICol || undefined,
        noImpulse: p16085.noImpulse,
        canDest: p16085.canDest,
        breakSnd: p16085.breakSnd,
        startDest: p16085.canDest && p16085.startDest,
        spawnChance: p16085.spawnChance,
        respawnT: UTILS.isNumber(p16085.respawnT) && p16085.respawnT > 0 ? p16085.respawnT : undefined,
        respawnR: p16085.respawnR,
        transparent: !!p16085.transparent || !!UTILS.isTransTex(p16085.src) || undefined,
        penetrable: p16085.penetrable > 0 ? p16085.penetrable : undefined,
        isBorder: p16085.isBorder,
        complexMesh: !!p16085.xR || !!p16085.yR || !!p16085.zR || !!UTILS.isTransTex(p16085.src) || undefined,
        trigger: p16085.trig,
        interface: p16085.interface,
        dynamic: p16085.dynamic,
        complexColl: !!p16085.complexColl || undefined,
        noMinimap: p16085.noMinimap
      });
      this.objects.push(v12836);
      this.addHelpers(p16085, v12835);
    }
    p16085.autoMatrix = !!p16085.health || !!p16085.canDest || p16085.interface;
    if (RENDER && !p16085.noVis) {
      p16085.transparent = p16085.fTrans || UTILS.isTransTex(p16085.src) || p16085.opacity != 1;
      if (UTILS.isTransTex(p16085.src)) {
        p16085.depthWrite = p16085.opacity == 1;
        p16085.alphaTest = p16085.transparent ? 0.02 : 0;
      }
      if (p16085.rside) {
        p16085.rside = UTILS.limitMM(parseInt(p16085.rside) || 0, 0, 2);
      }
      p16085.noEmisTex = true;
      p16085.vertexColors = true;
      p16085.scale = p16085.scale == null ? 1 : p16085.scale;
      p16085.shadows = !p16085.shadowsR && p16085.opacity == 1;
      if (p16085.shaderBased) {
        RENDER.ShaderMesh.addBuild(p16078, p16079, p16080, p16081, p16083, p16082, {
          type: p16085.type || undefined,
          src: p16085.src,
          model: p16085.model,
          uid: v12835,
          colr: p16085.colr || "#ff0000",
          emissive: null,
          opacity: 1,
          xR: p16085.xR || 0
        });
      } else {
        var v12837 = RENDER.addCube(p16078, p16079, p16080, p16081, p16083, p16082, p16084, p16085);
        if ((p16085.health || p16085.canDest) && !p16085.noCol) {
          this.objects[this.objects.length - 1].meshRef = v12837;
        }
      }
    }
    return v12836;
  };
  this.addSphere = function (p16086, p16087, p16088, p16089, p16090, p16091, p16092) {
    p16092 = p16092 || {};
    p16092.src = p16092.src || "wall_0";
    p16092.texOffX = UTILS.limitMM(p16092.texOffX, 0, 1).round(2);
    p16092.texOffY = UTILS.limitMM(p16092.texOffY, 0, 1).round(2);
    p16092.texRot = UTILS.limitMM(p16092.texRot, 0, 360);
    if (p16092.frames) {
      p16092.frames = UTILS.limitMM(parseInt(p16092.frames) || 0, 0, 100);
      p16092.frameT = UTILS.limitMM(parseFloat(p16092.frameT) || 0, 0, 10).round(1) * 100;
    }
    p16092.texEncode = UTILS.limitMM(p16092.texEncode, 0, config.encodingTypes.length - 1);
    if (p16092.health) {
      p16092.canDest = true;
    }
    if (p16092.complexColl && p16092.canDest) {
      p16092.complexColl = false;
    }
    if (RENDER && !p16092.noVis) {
      p16092.transparent = p16092.fTrans || UTILS.isTransTex(p16092.src) || p16092.opacity != 1;
      if (UTILS.isTransTex(p16092.src)) {
        p16092.depthWrite = p16092.opacity == 1;
        p16092.alphaTest = p16092.transparent ? 0.02 : 0;
      }
      p16092.noEmisTex = true;
      p16092.vertexColors = true;
      p16092.scale = p16092.scale == null ? 1 : p16092.scale;
      p16092.shadows = false;
      p16092.shadowsR = false;
      p16092.side = THREE.DoubleSide;
      RENDER.addSphere(p16086, p16087, p16088, p16089, p16091, p16090, p16092);
    }
  };
  this.addCanvas = function (p16093, p16094, p16095, p16096, p16097, p16098, p16099, p16100, p16101) {
    p16098 = p16098 || {};
    if (RENDER) {
      p16098.canvas = UTILS.createCanvasText(p16096 * 2, p16097 * 2, p16098.text || "Hello World", p16098.fontSize || 10, p16098.fcolr || "#000", p16098.bcolr || "#fff", p16098.noBVis, p16098.tAlign || 0, p16098.ocolr || "#626262", p16098.othick, !!p16098.noSCF);
      p16098.transparent = true;
      p16098.depthWrite = true;
      p16098.alphaTest = 0.02;
      p16098.renderVisD = 400;
      p16098.noGroup = true;
      p16098.side = THREE.DoubleSide;
      p16098.noShader = true;
      if (p16098.mimicSprite) {
        p16098.color = p16098.colr || "#FFFFFF";
        p16098.mat = THREE.SpriteMaterial;
        RENDER.addSprite(p16093, p16094, p16095, p16096, p16097, p16098);
      } else {
        RENDER.addFixedPlane(p16093, p16094, p16095, p16096, p16097, p16098, p16099, p16100, p16101);
      }
    }
  };
  this.addLeaderBoard = function (p16102, p16103, p16104, p16105, p16106, p16107, p16108, p16109, p16110) {
    p16107 = p16107 || {};
    p16107.leaderType = ["score", "time"][UTILS.limitMM(p16107.leaderType, 0, 1)];
    p16107.leaderTypeCust = p16107.leaderTypeCust && UTILS.isString(p16107.leaderTypeCust) ? p16107.leaderTypeCust.toString().replace(/[^a-z0-9_]+/gmi, "").substring(0, 10) : "";
    if (p16107.leaderTypeCust.length) {
      p16107.leaderType = p16107.leaderTypeCust;
    }
    p16107.leaderOrder = UTILS.limitMM(p16107.leaderOrder, 0, 1);
    p16107.leaderResults = UTILS.limitMM(parseInt(p16107.leaderResults) || 25, 1, 50);
    this.pendingLeaders.push({
      data: p16107,
      x: p16102,
      y: p16103,
      z: p16104,
      w: p16105,
      l: p16106,
      xR: p16108,
      yR: p16109,
      zR: p16110
    });
  };
  this.addCamera = function (p16111, p16112, p16113, p16114) {
    p16114 = p16114 || {};
    p16114.objLink = p16114.objLink || 0;
    p16114.camType = UTILS.limitMM(p16114.camType, 0, config.cameraTypes.length - 1);
    if (p16114.followPath) {
      if (UTILS.isString(p16114.followPath) && p16114.followPath != "") {
        if (/[^\d,]+/gmi.test(p16114.followPath)) {
          p16114.followPath = "";
        }
      } else {
        p16114.followPath = "";
      }
    } else {
      p16114.followPath = "";
    }
    if (p16114.camType == 0) {
      if (!this.spectateCams[p16114.objLink]) {
        this.spectateCams[p16114.objLink] = [];
      }
      this.spectateCams[p16114.objLink].push(new GameObject({
        x: p16111,
        z: p16113,
        y: p16112 + 5,
        xR: p16114.xR,
        yR: p16114.yR,
        zR: p16114.zR
      }));
    } else {
      p16114.camType == 1;
    }
  };
  this.addMesh = function (p16115, p16116, p16117, p16118, p16119, p16120, p16121, p16122) {
    p16122 = p16122 || {};
    if (p16122.mSize) {
      p16122.mSize = UTILS.limitMM(p16122.mSize, 0.01, 100).round(2);
    }
    v12693 = p15699.getPrefabByName(p16122.src.toUpperCase());
    p16122.texEncode = UTILS.limitMM(p16122.texEncode, 0, config.encodingTypes.length - 1);
    p16122.texVar = v12693 && v12693.variants ? UTILS.limitMM(p16122.texVar, 0, v12693.variants.length - 1) : undefined;
    if (p16122.interface) {
      p16122.interface = UTILS.limitMM(p16122.interface, 0, config.interfaceIDMax);
    }
    if (p16122.interfaceT) {
      p16122.interfaceT = UTILS.limitMM(p16122.interfaceT, 0, config.interfaceIDMax);
    }
    if (p16122.health) {
      p16122.canDest = true;
    }
    p16122.spin = UTILS.limitMM(p16122.spin, -20, 20);
    p16122.spinAxis = UTILS.limitMM(p16122.spinAxis, 0, 1);
    if (p16122.spin != 0) {
      p16122.rAnim = (p16122.spin || 0) * config.diskSpin;
      p16122.rAnimA = p16122.spinAxis ? "x" : "y";
    }
    p16122.spawnChance = UTILS.limitMM(parseFloat(p16122.spawnChance) || 0, 0, 100).round(2);
    if (!p16122.spawnChance) {
      p16122.spawnChance = undefined;
    }
    var v12838 = v12693 && v12693.complex;
    if (v12693 && p16122.texVar && v12693.variants && v12693.variants[p16122.texVar].complex) {
      v12838 = true;
    }
    if (!p16122.noCol) {
      var v12839 = new GameObject({
        complexMesh: !!v12838 || undefined,
        aoM: v12693 ? v12693.aoMlt || 0 : 0,
        propID: v12693.isProp ? p16122.src : undefined,
        x: p16115,
        z: p16117,
        y: p16116 + p16120,
        w: p16119,
        l: p16121,
        h: p16120,
        s: p16122.sound || undefined,
        uid: this.objects.length,
        noVis: p16122.noVis,
        noAmb: p16122.noAmb,
        health: p16122.health || undefined,
        notWallJ: p16122.notWallJ,
        noGrapple: p16122.noGrapple,
        noShoot: !!p16122.noShoot || undefined,
        noAICol: !!p16122.noAICol || undefined,
        noImpulse: p16122.noImpulse,
        canDest: p16122.canDest,
        startDest: p16122.canDest && p16122.startDest,
        spawnChance: p16122.spawnChance,
        respawnT: UTILS.isNumber(p16122.respawnT) && p16122.respawnT > 0 ? p16122.respawnT : undefined,
        respawnR: p16122.respawnR,
        interface: p16122.interface,
        isEvent: p16122.src.toUpperCase() == "EVENT",
        noMinimap: v12693.noMinimap || p16122.noMinimap
      });
      this.objects.push(v12839);
      this.addHelpers(p16122, this.objects.length - 1);
    }
    if ((!RENDER || !!RENDER.mapDet || !v12693.noDetail) && (v12693 && v12693.transparent && (p16116 += UTILS.randFloat(-0.01, 0.01)), RENDER && !p16122.noVis)) {
      var v12840 = v12693.emiss;
      p16122.src += "_0";
      if (v12693 && p16122.texVar && v12693.variants && v12693.variants[p16122.texVar]) {
        if (v12693.variants[p16122.texVar].diffM) {
          p16122.src = p16122.src + "_" + v12693.variants[p16122.texVar].id;
          p16122.texSrc = null;
        } else {
          p16122.texSrc = p16122.src + "_" + v12693.variants[p16122.texVar].id;
        }
        if (v12693.variants[p16122.texVar].noEmis) {
          v12840 = false;
        }
      } else if (v12693 && v12693.texRange) {
        var v12841 = UTILS.randInt(0, v12693.texRange);
        p16122.texSrc = p16122.src + (v12841 > 0 ? "_" + v12841 : "");
      }
      var v12842 = RENDER.loadMesh({
        isMdl: true,
        src: p16122.src,
        texVar: p16122.texVar,
        texSrc: p16122.texSrc,
        emissive: v12840 ? "#ffffff" : null,
        opacity: p16122.opacity,
        side: v12693.doubleSide ? THREE.DoubleSide : THREE.FrontSide,
        transparent: v12693.transparent || p16122.transparent || p16122.opacity != 1,
        shadows: v12693.castShadow,
        shadowsR: v12693.receiveShadow,
        vertexColors: true,
        color: p16122.colr || "#ffffff",
        backup: [p16119, p16121, p16120],
        mat: p16122.mat,
        frames: v12693.frames ? v12693.frames : undefined,
        frameT: v12693.frameT ? v12693.frameT : undefined,
        rAnim: p16122.rAnim,
        rAnimA: p16122.rAnimA,
        alphaTest: v12693.alphaTest || 0,
        offsetH: p16120
      }, p16115, p16116, p16117, p16118, p16122.mSize || v12693.scale, RENDER.scene, !p16122.spin && !p16122.health && !p16122.canDest && (!p16122.texSrc || !!v12693 && !!v12693.variants));
      if ((p16122.health || p16122.canDest) && !p16122.noCol) {
        this.objects[this.objects.length - 1].meshRef = v12842;
      }
    }
  };
  this.addAsset = function (p16123, p16124, p16125, p16126, p16127, p16128, p16129, p16130) {
    p16130 = p16130 || {};
    if (p16130.mSize) {
      p16130.mSize = UTILS.limitMM(p16130.mSize, 0.01, 100).round(2);
    }
    v12693 = p15699.getPrefabByName("CUSTOM_ASSET");
    if (!UTILS.isNumber(p16130.asset)) {
      p16130.asset += "";
    }
    if (!UTILS.isString(p16130.asset)) {
      p16130.asset = undefined;
    }
    var v12843 = (p16130.asset || "").includes("e");
    var v12844 = (p16130.asset || "").includes("n");
    var v12845 = (p16130.asset || "").includes("s");
    var v12846 = (p16130.asset || "").includes("a");
    var v12847 = (p16130.asset || "").includes("m");
    var v12848 = (p16130.asset || "").includes("r");
    var v12849 = (p16130.asset || "").includes("l");
    var v12850 = (p16130.asset || "").includes("p");
    var v12851 = (p16130.asset || "").includes("b");
    var v12852 = (p16130.asset || "").includes("g");
    var v12853 = (p16130.asset || "").includes("q");
    var v12854 = (p16130.asset || "").includes("f");
    p16130.alphaTest = UTILS.limitMM(parseInt(p16130.alphaTest) || 0, 0, 1).round(2);
    p16130.texEncode = UTILS.limitMM(parseInt(p16130.texEncode) || 0, 0, config.encodingTypes.length - 1);
    p16130.side = UTILS.limitMM(parseInt(p16130.side) || 0, 0, 2);
    p16130.spin = UTILS.limitMM(p16130.spin, -20, 20);
    p16130.spinAxis = UTILS.limitMM(p16130.spinAxis, 0, 1);
    p16130.hbh = UTILS.limitMM(p16130.hbh, 0.1, 10);
    p16130.hbw = UTILS.limitMM(p16130.hbw, 0.1, 10);
    if (p16130.spin != 0) {
      p16130.rAnim = (p16130.spin || 0) * config.diskSpin;
      p16130.rAnimA = p16130.spinAxis ? "x" : "y";
    }
    if (p16130.interface) {
      p16130.interface = UTILS.limitMM(p16130.interface, 0, config.interfaceIDMax);
    }
    if (p16130.interfaceT) {
      p16130.interfaceT = UTILS.limitMM(p16130.interfaceT, 0, config.interfaceIDMax);
    }
    if (p16130.health) {
      p16130.canDest = true;
    }
    if (p16130.startAnim && UTILS.isString(p16130.startAnim) && p16130.startAnim != "") {
      if (p16130.startAnim.length > 32) {
        p16130.startAnim = "";
      }
      if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(p16130.startAnim)) {
        p16130.startAnim = "";
      }
    } else {
      p16130.startAnim = "";
    }
    p16130.spawnChance = UTILS.limitMM(parseFloat(p16130.spawnChance) || 0, 0, 100).round(2);
    if (!p16130.spawnChance) {
      p16130.spawnChance = undefined;
    }
    if (p16130.complexColl && p16130.canDest) {
      p16130.complexColl = false;
    }
    if (!p16130.noCol) {
      var v12855 = new GameObject({
        complexMesh: true,
        aoM: 0,
        x: p16123,
        z: p16125,
        y: p16124 + p16128 * (p16130.hbh || 1),
        w: p16127 * (p16130.hbw || 1),
        l: p16129 * (p16130.hbw || 1),
        h: p16128 * (p16130.hbh || 1),
        uid: this.objects.length,
        noVis: p16130.noVis,
        noAmb: p16130.noAmb,
        health: p16130.health || undefined,
        notWallJ: p16130.notWallJ,
        noGrapple: p16130.noGrapple,
        noShoot: !!p16130.noShoot || undefined,
        noAICol: !!p16130.noAICol || undefined,
        noImpulse: p16130.noImpulse,
        canDest: p16130.canDest,
        startDest: p16130.canDest && p16130.startDest,
        spawnChance: p16130.spawnChance,
        respawnT: UTILS.isNumber(p16130.respawnT) && p16130.respawnT > 0 ? p16130.respawnT : undefined,
        respawnR: p16130.respawnR,
        interface: p16130.interface,
        asset: p16130.asset,
        hasAnim: !!v12852 || !!v12853 || !!v12854 || undefined,
        complexColl: !!p16130.complexColl || undefined,
        noMinimap: p16130.noMinimap
      });
      this.objects.push(v12855);
      this.addHelpers(p16130, this.objects.length - 1);
    }
    if (v12693 && v12693.transparent) {
      p16124 += UTILS.randFloat(-0.01, 0.01);
    }
    if (RENDER && !p16130.noVis) {
      var v12856 = (p16130.asset || "").replace(/[^\d]/g, "");
      var v12857 = RENDER[v12852 || v12853 || v12854 ? "loadAnimMesh" : "loadMesh"]({
        isMdl: true,
        fileExt: v12853 ? "glb" : v12852 ? "gltf" : v12854 ? "fbx" : null,
        src: v12856 + "/" + p16130.src,
        texSrc: p16130.texSrc,
        emissive: v12843 ? "#ffffff" : null,
        opacity: p16130.opacity,
        transparent: p16130.fTrans || p16130.transparent || p16130.opacity != 1,
        shadows: p16130.cast || !p16130.receive && p16130.opacity == 1,
        shadowsR: p16130.receive,
        vertexColors: true,
        color: p16130.colr || "#ffffff",
        noGroup: !!p16130.health || !!p16130.canDest,
        backup: [p16127, p16129, p16128],
        normal: v12844,
        spec: v12845,
        alphaTest: p16130.alphaTest || (v12846 ? 0.02 : 0),
        asset: v12856,
        tFilter: p16130.noSmooth ? THREE.NearestFilter : THREE.LinearFilter,
        rAnim: p16130.rAnim,
        rAnimA: p16130.rAnimA,
        animS: p16130.animS,
        startAnim: p16130.startAnim,
        metalness: v12847 ? 1 : 0,
        roughness: v12848 ? 1 : 0,
        lightM: v12849 ? 1 : 0,
        uv2: !!v12849 || undefined,
        displacement: v12850 ? 1 : 0,
        bump: v12851 ? 1 : 0,
        canDest: p16130.canDest,
        side: p16130.side,
        noFog: p16130.noFog,
        offsetH: v12852 || v12853 || v12854 ? 0 : p16128,
        texEncode: p16130.texEncode
      }, p16123, p16124, p16125, p16126, p16130.mSize || 1, RENDER.scene, !p16130.spin && !p16130.health && !p16130.canDest && !p16130.texSrc);
      if ((p16130.health || p16130.canDest || v12852 || v12853 || v12854) && !p16130.noCol) {
        this.objects[this.objects.length - 1].meshRef = v12857;
      }
    }
  };
  this.addPathNode = function (p16131, p16132, p16133, p16134) {
    if (p16134 && p16134.id != null) {
      this.pathNodes[p16134.id] = {
        id: p16134.id,
        node: true,
        x: p16131,
        y: p16132,
        z: p16133
      };
    }
  };
  this.buildAIData = function (p16135, p16136) {
    return {
      src: p16135.aid ? "model" : "ghost_0",
      asset: p16135.aid,
      pjA: p16135.pra,
      pjG: p16135.prg == null ? 0 : parseFloat(p16135.prg),
      pjSC: parseFloat(p16135.prsc) || 1,
      pjMS: parseFloat(p16135.prms) || 1,
      pjS: p16135.prs == null ? 1 : parseFloat(p16135.prs),
      pjSp: parseInt(p16135.pjs) || 1,
      pjD: parseInt(p16135.pjd) || 100,
      pjGL: p16135.prgl != null || undefined,
      pjT: p16135.prgt != null || undefined,
      health: parseInt(p16135.h || p16135.hp) || 0,
      respawnT: (parseFloat(p16135.rt) || 0) * 1000,
      respawnR: p16135.rr != null || undefined,
      speed: p16135.spd == null ? 1 : parseFloat(p16135.spd) || 0,
      turnSpd: p16135.tsd == null ? 1 : parseFloat(p16135.tsd) || 0,
      roamTime: parseInt(p16135.rmt) || 1000,
      roamRad: parseInt(p16135.rmr) || 0,
      grv: p16135.grv == null ? 1 : parseFloat(p16135.grv) || 0,
      frate: parseInt(p16135.fr) || 2000,
      aicur: parseFloat(p16135.aac) || 0,
      shoBrk: parseInt(p16135.shb) || 400,
      shoArY: parseInt(p16135.sha) || 0,
      shoOffH: p16135.shof == null,
      shoDel: parseInt(p16135.shdy) || 0,
      melDel: parseInt(p16135.mldy) || 400,
      melShake: parseFloat(p16135.mls) || 0,
      shoShake: parseFloat(p16135.ss) || 0,
      shotEff: p16135.se == null ? undefined : parseInt(p16135.se) || 0,
      hitEff: p16135.he == null ? undefined : parseInt(p16135.he) || 0,
      critDmg: parseFloat(p16135.crd) || 0,
      critHei: parseFloat(p16135.crh) || 0,
      hrate: parseInt(p16135.hr) || 800,
      melrng: parseInt(p16135.mlr) || 10,
      melrad: parseFloat(p16135.mlra) || 0,
      aiChasd: parseInt(p16135.aic) || 10,
      meldmg: parseInt(p16135.mld) || 10,
      visDis: parseInt(p16135.vd) || 120,
      idl: parseInt(p16135.idl) || 0,
      dth: parseInt(p16135.dth) || 0,
      atk: parseInt(p16135.atk) || 0,
      atkh: parseInt(p16135.atkh) || 0,
      mel: parseInt(p16135.mel) || 0,
      melh: parseInt(p16135.melh) || 0,
      agr: parseInt(p16135.agr) || 0,
      score: parseInt(p16135.sp) || 0,
      reward: p16135.rew,
      rewardMethod: parseInt(p16135.rewm) || 0,
      rewardReq: parseInt(p16135.rewr) || 0,
      rewardNode: parseInt(p16135.rewn) || 0,
      behav: parseInt(p16135.bh) || 0,
      ignoreOnStuck: p16135.igos != null || undefined,
      driftOnStuck: p16135.dos != null || undefined,
      invincibleOnStuck: p16135.ivos != null || undefined,
      canShoot: p16135.cs != null || undefined,
      canHit: p16135.cnh != null || undefined,
      xrayVis: p16135.xv != null || undefined,
      targAI: p16135.tAi != null || undefined,
      targPlr: p16135.tPl == null || undefined,
      friendly: p16135.aif != null,
      explode: p16135.exp != null,
      colr: p16135.c,
      noCol: p16135.l || p16135.col,
      noVis: p16135.v,
      mSize: parseFloat(p16135.ms),
      mYOff: parseFloat(p16135.myo) || 0,
      mROff: parseFloat(p16135.mro) || 0,
      aiName: p16135.ain,
      lvl: parseInt(p16135.ail) || 0,
      tagScale: parseFloat(p16135.ains) || 1,
      constE: parseInt(p16135.tce) || 0,
      event: parseInt(p16135.te) || 0,
      canTrigger: p16135.ct != null || undefined,
      canDest: p16135.cdy != null || undefined,
      startDest: p16135.sd != null || undefined,
      spawnChance: parseFloat(p16135.rsc || 0) || 0,
      chance: parseInt(p16135.cha) || 0,
      eventN: p16136.events[parseInt(p16135.te) || 15] ? p16136.events[parseInt(p16135.te) || 15].name : null,
      interface: parseInt(p16135.in) || undefined,
      interfaceT: parseInt(p16135.tin) || undefined,
      team: parseInt(p16135.tm || 0) || 0,
      actions: p16135.tas && Array.isArray(p16135.tas) ? p16135.tas : null,
      animS: parseFloat(p16135.as) || 0,
      soundR: parseFloat(p16135.sor) || 0,
      startAnim: p16135.ast,
      hbh: parseFloat(p16135.hbh) || 1,
      hbw: parseFloat(p16135.hbw) || 1,
      pathType: parseInt(p16135.pht || 0) || 0,
      pathInput: p16135.phi,
      texEncode: parseInt(p16135.ten) || 0,
      noFog: p16135.nf != null || undefined,
      side: parseInt(p16135.rs) || 0,
      fTrans: p16135.ft != null || undefined,
      noSmooth: p16135.txs != null || undefined,
      alphaTest: parseFloat(p16135.alt || 0) || 0,
      opacity: p16135.o != 1 && p16135.o != null ? p16135.o : 1,
      frames: UTILS.limitMM(parseInt(p16135.fct) || 0, 0, 100),
      frameT: UTILS.limitMM(parseFloat(p16135.fs) || 0, 0, 10).round(1) * 100,
      bobS: UTILS.limitMM(parseInt(p16135.bbS) || 0, 0, 10).round(2) / 1000,
      bobD: UTILS.limitMM(parseInt(p16135.bbD) || 0, 0, 10).round(2),
      pMov: p16135.pmv != null || undefined,
      spin: parseFloat(p16135.spn || 0) || 0,
      spinAxis: parseInt(p16135.spa || 0) || 0
    };
  };
  this.addAI = function (p16137, p16138, p16139, p16140, p16141, p16142, p16143, p16144, p16145, p16146) {
    if (!!p16146 || !RENDER && !(this.pendingAIs.length >= config.aiLimit)) {
      p16144 = p16144 || {};
      if (!p16144.aid) {
        p16144.fct = 2;
        p16144.fs = 5;
        p16144.rs = 2;
      }
      p16144 = this.buildAIData(p16144, p16145);
      if (p16144.mSize) {
        p16144.mSize = UTILS.limitMM(p16144.mSize, 0.01, 100).round(2);
      }
      if (p16144.mYOff) {
        p16144.mYOff = UTILS.limitMM(p16144.mYOff, -100, 100);
      }
      p16144.spin = UTILS.limitMM(p16144.spin, -20, 20);
      p16144.spinAxis = UTILS.limitMM(p16144.spinAxis, 0, 1);
      if (p16144.spin != 0) {
        p16144.rAnim = (p16144.spin || 0) * config.diskSpin;
        p16144.rAnimA = p16144.spinAxis ? "x" : "y";
      }
      p16144.side = UTILS.limitMM(parseInt(p16144.side) || 0, 0, 2);
      p16144.tagScale = UTILS.limitMM(p16144.tagScale, 0, 10);
      p16144.lvl = UTILS.limitMM(p16144.lvl, 0, 999);
      p16144.speed = UTILS.limitMM(p16144.speed, 0, 10);
      p16144.turnSpd = UTILS.limitMM(p16144.turnSpd, 0, 30);
      p16144.roamTime = UTILS.limitMM(p16144.roamTime, 1000, 10000);
      p16144.roamRad = UTILS.limitMM(p16144.roamRad, 0, 500);
      p16144.aiChasd = UTILS.limitMM(p16144.aiChasd, 0, 2000);
      p16144.grv = UTILS.limitMM(p16144.grv, 0, 1);
      p16144.pjG = UTILS.limitMM(p16144.pjG, -2, 2);
      p16144.pjSC = UTILS.limitMM(p16144.pjSC, 0.1, 10);
      p16144.pjMS = UTILS.limitMM(p16144.pjMS, 0.01, 10);
      p16144.pjS = UTILS.limitMM(p16144.pjS, 0, 20);
      p16144.pjD = UTILS.limitMM(p16144.pjD, 0, 1000);
      p16144.hbh = UTILS.limitMM(p16144.hbh, 0.1, 10);
      p16144.hbw = UTILS.limitMM(p16144.hbw, 0.1, 10);
      p16144.frate = UTILS.limitMM(p16144.frate, 200, 10000);
      p16144.aicur = UTILS.limitMM(p16144.aicur, 0, 10);
      p16144.shoBrk = UTILS.limitMM(p16144.shoBrk, 0, 5000);
      p16144.shoArY = UTILS.limitMM(p16144.shoArY, -90, 90);
      p16144.shoDel = UTILS.limitMM(p16144.shoDel, 0, 5000);
      p16144.melDel = UTILS.limitMM(p16144.melDel, 0, 5000);
      p16144.melShake = UTILS.limitMM(p16144.melShake, 0, 1);
      p16144.shoShake = UTILS.limitMM(p16144.shoShake, 0, 1);
      if (p16144.shotEff != null) {
        p16144.shotEff = UTILS.limitMM(p16144.shotEff, 0, 9);
      }
      if (p16144.hitEff != null) {
        p16144.hitEff = UTILS.limitMM(p16144.hitEff, 0, 9);
      }
      p16144.critDmg = UTILS.limitMM(p16144.critDmg, 0, 5);
      p16144.critHei = UTILS.limitMM(p16144.critHei, 0, 10);
      p16144.hrate = UTILS.limitMM(p16144.hrate, 200, 10000);
      p16144.melrng = UTILS.limitMM(p16144.melrng, 10, 100);
      p16144.melrad = UTILS.limitMM(p16144.melrad, 0, Math.PI * 2);
      p16144.meldmg = UTILS.limitMM(p16144.meldmg, 1, 200);
      p16144.visDis = UTILS.limitMM(p16144.visDis, 1, 1000);
      p16144.score = UTILS.limitMM(p16144.score, 0, 10000);
      p16144.proj = UTILS.limitMM(p16144.proj, 0, 5);
      p16144.behav = UTILS.limitMM(p16144.behav, 0, 20);
      p16144.pathType = UTILS.limitMM(p16144.pathType, 0, config.pathTypes.length - 1);
      p16144.texEncode = UTILS.limitMM(p16144.texEncode, 0, config.encodingTypes.length - 1);
      p16144.alphaTest = UTILS.limitMM(parseInt(p16144.alphaTest) || 0, 0, 1).round(2);
      if (p16144.pathInput) {
        if (UTILS.isString(p16144.pathInput) && p16144.pathInput != "") {
          if (/[^\d,]+/gmi.test(p16144.pathInput)) {
            p16144.pathInput = "";
          }
        } else {
          p16144.pathInput = "";
        }
      } else {
        p16144.pathInput = "";
      }
      p16144.reward = UTILS.isString(p16144.reward) ? p16144.reward.split(",") : null;
      if (p16144.startAnim && UTILS.isString(p16144.startAnim) && p16144.startAnim != "") {
        if (p16144.startAnim.length > 32) {
          p16144.startAnim = "";
        }
        if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(p16144.startAnim)) {
          p16144.startAnim = "";
        }
      } else {
        p16144.startAnim = "";
      }
      p16144.spawnChance = UTILS.limitMM(parseFloat(p16144.spawnChance) || 0, 0, 100).round(2);
      if (!p16144.spawnChance) {
        p16144.spawnChance = undefined;
      }
      p16144.startDest = p16144.canDest && p16144.startDest;
      if (p16144.interface) {
        p16144.interface = UTILS.limitMM(p16144.interface, 0, config.interfaceIDMax);
      }
      if (p16144.interfaceT) {
        p16144.interfaceT = UTILS.limitMM(p16144.interfaceT, 0, config.interfaceIDMax);
      }
      p16144.eventN = p16144.canTrigger ? p16144.eventN : null;
      if (p16144.eventN && !p16144.eventN.includes("onAI")) {
        p16144.eventN = null;
      }
      if (p16144.aiName) {
        if (UTILS.isString(p16144.aiName) && p16144.aiName != "") {
          if (p16144.aiName.length > 16) {
            p16144.aiName = "";
          }
          if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(p16144.aiName)) {
            p16144.aiName = "";
          }
        } else {
          p16144.aiName = "";
        }
      } else {
        p16144.aiName = "";
      }
      p16144.constE = UTILS.limitMM(p16144.constE, 0, 10000);
      p16144.chance = UTILS.limitMM(p16144.chance, 0, 100);
      var vA706 = [];
      if (p16144.actions) {
        for (var vLN02294 = 0; vLN02294 < p16144.actions.length; vLN02294++) {
          if (p16144.actions[vLN02294]) {
            var v12858 = parseInt(p16144.actions[vLN02294].tc) || 0;
            var v12859 = parseInt(p16144.actions[vLN02294].tc2) || 0;
            var v12860 = p16144.actions[vLN02294].tct;
            var v12861 = p16144.actions[vLN02294].tcc;
            var v12862 = parseInt(p16144.actions[vLN02294].tce) || 0;
            var v12863 = parseInt(p16144.actions[vLN02294].ta) || 0;
            var v12864 = parseInt(p16144.actions[vLN02294].esa || p16144.actions[vLN02294].es) || 0;
            var v12865 = p16144.actions[vLN02294].esa != null;
            var v12866 = parseFloat(p16144.actions[vLN02294].ev) || 1;
            var v12867 = parseFloat(p16144.actions[vLN02294].er) || 1;
            var v12868 = parseInt(p16144.actions[vLN02294].ef) || 0;
            var v12869 = parseFloat(p16144.actions[vLN02294].tad) || 0;
            var v12870 = parseInt(p16144.actions[vLN02294].cd) || 0;
            var vO412 = {};
            if (!p16145.conditions[v12870]) {
              v12870 = 0;
            }
            var v12871 = p16145.conditions[v12870];
            if (v12871 && v12871.vals) {
              var v12872;
              for (var vLN02295 = 0; vLN02295 < v12871.vals.length; vLN02295++) {
                v12872 = v12871.vals[vLN02295].def;
                if (p16144.actions[vLN02294]["cv" + vLN02295] == null) {
                  vO412[vLN02295] = v12872;
                  continue;
                }
                if (v12871.vals[vLN02295].bool) {
                  v12872 = !!p16144.actions[vLN02294]["cv" + vLN02295];
                } else if (v12871.vals[vLN02295].input) {
                  p16144.actions[vLN02294]["cv" + vLN02295] = p16144.actions[vLN02294]["cv" + vLN02295] + "";
                  v12872 = UTILS.isString(p16144.actions[vLN02294]["cv" + vLN02295]) ? (p16144.actions[vLN02294]["cv" + vLN02295] || "").toString().replace(/[^a-z0-9_]+/gmi, "").substring(0, v12871.vals[vLN02295].len) : v12871.vals[vLN02295].def;
                } else if (v12871.vals[vLN02295].select) {
                  v12872 = UTILS.limitMM(parseInt(p16144.actions[vLN02294]["cv" + vLN02295]) || v12872, 0, v12871.vals[vLN02295].select.length - 1);
                } else if (UTILS.isNumber(p16144.actions[vLN02294]["cv" + vLN02295])) {
                  v12872 = UTILS.limitMM(parseFloat(p16144.actions[vLN02294]["cv" + vLN02295]) || v12872, v12871.vals[vLN02295].min, v12871.vals[vLN02295].max);
                } else {
                  v12872 = v12871.vals[vLN02295].def;
                }
                vO412[vLN02295] = v12872;
              }
            }
            v12864 = v12865 ? v12864 : config.emitterSounds[v12864] ? config.emitterSounds[v12864] : config.emitterSounds[0];
            v12866 = UTILS.limitMM(v12866, config.emitterVolMin, config.emitterVolMax);
            v12867 = UTILS.limitMM(v12867, config.emitterRateMin, config.emitterRateMax);
            v12868 = UTILS.limitMM(v12868, 0, 2);
            v12869 = UTILS.limitMM(v12869, 0, 60).round(1);
            if (v12860) {
              if (v12860 && UTILS.isString(v12860) && v12860 != "") {
                if (v12860.length > 70) {
                  v12860 = undefined;
                }
                if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(v12860)) {
                  v12860 = undefined;
                }
              } else {
                v12860 = undefined;
              }
            } else {
              v12860 = undefined;
            }
            if ((v12863 == 37 || v12863 == 38) && v12860 != null) {
              v12860 = v12860.toString().replace(/[^a-z0-9_]+/gmi, "").substring(0, 10);
            }
            v12861 = v12861 && UTILS.isString(v12861) ? v12861.toString().replace(/[^a-z0-9_]+/gmi, "").substring(0, 10) : undefined;
            var vO413 = {};
            if (v12858) {
              vO413.trigConst = v12858;
            }
            if (v12859) {
              vO413.trigConst2 = v12859;
            }
            if (v12860 != null) {
              vO413.trigConstTx = v12860;
            }
            if (v12861 != null) {
              vO413.trigConstC = v12861;
            }
            if (v12862) {
              vO413.trigConstT = v12862;
            }
            if (v12863) {
              vO413.trigAct = v12863;
            }
            if (v12869) {
              vO413.trigDelay = v12869;
            }
            if (v12870) {
              vO413.trigCond = [v12870, vO412[0], vO412[1], vO412[2]];
            }
            if (v12864 != "nuke_0" || v12866 != 1 || v12867 != 1 || v12868 != 0 || !!v12865) {
              vO413.triggerSound = [v12864, v12866, v12867, v12868, v12865];
            }
            vA706.push(vO413);
          }
        }
      }
      p16144.actions = vA706;
      var vO414 = {
        data: p16144,
        x: p16137,
        y: p16138,
        z: p16139,
        r: p16140,
        w: p16141,
        h: p16142,
        l: p16143
      };
      if (p16146) {
        return vO414;
      } else {
        this.pendingAIs.push(vO414);
        return;
      }
    }
  };
  this.addPendingAIs = function (p16147, p16148) {
    for (var vLN02296 = 0; vLN02296 < this.pendingAIs.length; ++vLN02296) {
      v12693 = this.pendingAIs[vLN02296];
      var v12873 = v12693.data;
      var v12874 = !v12873.canDest || !v12873.startDest;
      if (!p16148 && v12873.spawnChance && v12873.startDest && v12873.canDest && UTILS.randFloat(0, 100) <= v12873.spawnChance) {
        v12874 = true;
      }
      if (v12873 && v12874) {
        p16147.spawn(null, 0, v12873.aiName, v12693.x, v12693.y, v12693.z, v12873);
      }
    }
  };
  this.buildBotData = function (p16149) {
    return {
      name: p16149.btn,
      class: parseInt(p16149.btc) || 0,
      lives: parseInt(p16149.btl) || 0,
      team: parseInt(p16149.btt) || 0,
      healthMlt: parseFloat(p16149.bthm) || 1,
      dmgMlt: parseFloat(p16149.btdm) || 1,
      speedMlt: parseFloat(p16149.btspm) || 1,
      rangeMlt: parseFloat(p16149.btrm) || 1,
      spreadMlt: parseFloat(p16149.btsm) || 1,
      forceClass: p16149.btfc != null,
      targetBots: p16149.bttc != null,
      targetTeam: p16149.bttt != null,
      forceCrouch: p16149.btfcr != null,
      attackTarget: p16149.btat == null,
      followTarget: p16149.btft == null,
      watchTarget: p16149.btwt == null,
      mimicTarget: p16149.btmt != null,
      slideHop: p16149.btsh != null,
      canRespawn: p16149.btcr == null,
      useSpawnDelay: p16149.btsd == null,
      removeOnDeath: p16149.btrd == null,
      nodYes: p16149.btny != null,
      nodNo: p16149.btno != null,
      joinMessage: p16149.btjm != null,
      leaveMessage: p16149.btlm != null,
      voiceChat: p16149.btvc == null,
      godMode: p16149.btgm != null,
      roam: p16149.btr == null,
      randomSpawn: p16149.btrs != null,
      recoil: p16149.btrc == null,
      primSkin: parseInt(p16149.btcpr) || -1,
      dye: parseInt(p16149.btcd) || -1,
      face: parseInt(p16149.btcf) || -1,
      hat: parseInt(p16149.btcht) || -1,
      head: parseInt(p16149.btch) || -1,
      back: parseInt(p16149.btcbk) || -1,
      body: parseInt(p16149.btcb) || -1,
      waist: parseInt(p16149.btcw) || -1,
      wrist: parseInt(p16149.btcwr) || -1,
      shoes: parseInt(p16149.btcs) || -1,
      pet: parseInt(p16149.btcp) || -1,
      melee: parseInt(p16149.btcm) || -1
    };
  };
  this.addBot = function (p16150, p16151, p16152, p16153, p16154) {
    if (!RENDER && !(this.pendingBots.length >= config.botLimit)) {
      p16154 = p16154 || {};
      p16154 = this.buildBotData(p16154);
      if (p16154.name) {
        if (UTILS.isString(p16154.name) && p16154.name != "") {
          if (p16154.name.length > 16) {
            p16154.name = "";
          }
          if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(p16154.name)) {
            p16154.name = "";
          }
        } else {
          p16154.name = "";
        }
      } else {
        p16154.name = "";
      }
      var vO415 = {
        data: p16154,
        dir: p16153,
        x: p16150,
        y: p16151,
        z: p16152
      };
      this.pendingBots.push(vO415);
    }
  };
  this.addPendingBots = function (p16155) {
    for (var vLN02297 = 0; vLN02297 < this.pendingBots.length; ++vLN02297) {
      v12693 = this.pendingBots[vLN02297];
      p16155.add({
        x: v12693.x,
        y: v12693.y,
        z: v12693.z,
        dir: v12693.dir
      }, true, true, v12693.data);
    }
    p16155.sync();
  };
  this.updatePendingLeader = function (p16156, p16157) {
    if (this.pendingLeaders && this.pendingLeaders[p16156] && p16157 && p16157.length && (v12693 = this.pendingLeaders[p16156], RENDER)) {
      var v12875 = new THREE.Texture(UTILS.createLeaderText(v12693.w * 2, v12693.l * 2, p16157, v12693.data));
      v12875.wrapS = THREE.RepeatWrapping;
      v12875.wrapT = THREE.RepeatWrapping;
      v12875.repeat.set(v12693.data.repeatX || 1, v12693.data.repeatY || 1);
      v12875.minFilter = v12693.data.tFilter || THREE.NearestFilter;
      v12875.magFilter = v12693.data.tFilter || THREE.NearestFilter;
      v12875.needsUpdate = true;
      if (v12693.data.movT) {
        RENDER.movTextures.push({
          tex: v12875,
          mov: v12693.data.movT,
          movD: v12693.data.movD || 0
        });
      }
      if (v12693.meshRef) {
        v12693.meshRef.material.map = v12875;
      } else {
        v12693.data.transparent = true;
        v12693.data.depthWrite = true;
        v12693.data.alphaTest = 0.02;
        v12693.data.renderVisD = 400;
        v12693.data.noGroup = true;
        v12693.data.side = THREE.DoubleSide;
        v12693.data.noShader = true;
        v12693.data.skipMat = true;
        if (v12693.data.mimicSprite) {
          v12693.data.color = v12693.data.colr || "#FFFFFF";
          v12693.data.mat = THREE.SpriteMaterial;
          v12693.meshRef = RENDER.addSprite(v12693.x, v12693.y, v12693.z, v12693.w, v12693.l, v12693.data);
        } else {
          v12693.meshRef = RENDER.addFixedPlane(v12693.x, v12693.y, v12693.z, v12693.w, v12693.l, v12693.data, v12693.xR, v12693.yR, v12693.zR);
        }
        v12693.meshRef.material.map = v12875;
      }
    }
  };
  var vA707 = [];
  this.addNoisePlanes = function () {
    for (var vLN02298 = 0; vLN02298 < vA707.length; ++vLN02298) {
      vA707[vLN02298][5].objects = this.objects;
      var v12876 = RENDER.addFixedPlane(...vA707[vLN02298]);
      if (vA707[vLN02298].length == 10) {
        this.objects[vA707[vLN02298][9]].meshRef = v12876;
      }
    }
    vA707.length = 0;
  };
  this.addPlane = function (p16158, p16159, p16160, p16161, p16162, p16163, p16164, p16165, p16166) {
    p16163 = p16163 || {};
    p16163.penetrable = UTILS.limitMM(parseFloat(p16163.penetrable) || 0, 0, 1).round(2);
    if (p16163.texOffX) {
      p16163.texOffX = UTILS.limitMM(p16163.texOffX, 0, 1).round(2);
    }
    if (p16163.texOffY) {
      p16163.texOffY = UTILS.limitMM(p16163.texOffY, 0, 1).round(2);
    }
    if (p16163.frames) {
      p16163.frames = UTILS.limitMM(parseInt(p16163.frames) || 0, 0, 100);
      p16163.frameT = UTILS.limitMM(parseFloat(p16163.frameT) || 0, 0, 10).round(1) * 100;
    }
    p16163.texEncode = UTILS.limitMM(p16163.texEncode, 0, config.encodingTypes.length - 1);
    if (p16163.interface) {
      p16163.interface = UTILS.limitMM(p16163.interface, 0, config.interfaceIDMax);
    }
    if (p16163.interfaceT) {
      p16163.interfaceT = UTILS.limitMM(p16163.interfaceT, 0, config.interfaceIDMax);
    }
    if (p16163.health) {
      p16163.canDest = true;
    }
    p16163.spawnChance = UTILS.limitMM(parseFloat(p16163.spawnChance) || 0, 0, 100).round(2);
    if (!p16163.spawnChance) {
      p16163.spawnChance = undefined;
    }
    if (!p16163.noCol) {
      this.objects.push(new GameObject({
        x: p16158,
        z: p16160,
        y: p16159,
        w: p16162,
        l: p16161,
        h: 0,
        uid: this.objects.length,
        s: p16163.sound || undefined,
        health: p16163.health || undefined,
        notWallJ: p16163.notWallJ,
        noGrapple: p16163.noGrapple,
        noShoot: !!p16163.noShoot || undefined,
        noAICol: !!p16163.noAICol || undefined,
        noImpulse: p16163.noImpulse,
        respawnT: UTILS.isNumber(p16163.respawnT) && p16163.respawnT > 0 ? p16163.respawnT : undefined,
        respawnR: p16163.respawnR,
        transparent: !!p16163.transparent || !!UTILS.isTransTex(p16163.src) || undefined,
        penetrable: p16163.penetrable > 0 ? p16163.penetrable : undefined,
        noVis: p16163.noVis,
        noAmb: p16163.noAmb,
        interface: p16163.interface,
        canDest: p16163.canDest,
        startDest: p16163.canDest && p16163.startDest,
        spawnChance: p16163.spawnChance,
        noMinimap: p16163.noMinimap
      }));
    }
    if (!p16163.noCol && !p16163.noise && p16163.side != 2 && !p16163.asset) {
      this.objects[this.objects.length - 1].type = 1;
    }
    this.addHelpers(p16163, this.objects.length - 1);
    if (RENDER && !p16163.noVis) {
      p16163.refl = 1;
      p16163.noEmisTex = true;
      p16163.transparent = true;
      p16163.side = THREE.DoubleSide;
      p16163.vertexColors = true;
      p16163.shadowsR = true;
      if (p16163.noise) {
        p16163.pinEdges = true;
        p16163.margin = 5;
        p16163.tilesX = Math.round(p16162 / 5);
        p16163.tilesZ = Math.round(p16161 / 5);
      }
      p16163.noShader = !!p16163.noise;
      var vA708 = [p16158, p16159, p16160, p16162, p16161, p16163, p16164, (p16165 || 0) + Math.PI / 2, p16166];
      if (p16163.noise) {
        if ((p16163.health || p16163.canDest) && !p16163.noCol) {
          vA708.push(this.objects.length - 1);
        }
        vA707.push(vA708);
      } else {
        var v12877 = RENDER.addPlane(...vA708);
        if ((p16163.health || p16163.canDest) && !p16163.noCol) {
          this.objects[this.objects.length - 1].meshRef = v12877;
        }
      }
    }
  };
  this.addFixedPlane = function (p16167, p16168, p16169, p16170, p16171, p16172, p16173, p16174, p16175) {
    p16172 = p16172 || {};
    p16172.penetrable = UTILS.limitMM(parseFloat(p16172.penetrable) || 0, 0, 1).round(2);
    if (p16172.texOffX) {
      p16172.texOffX = UTILS.limitMM(p16172.texOffX, 0, 1).round(2);
    }
    if (p16172.texOffY) {
      p16172.texOffY = UTILS.limitMM(p16172.texOffY, 0, 1).round(2);
    }
    if (p16172.frames) {
      p16172.frames = UTILS.limitMM(parseInt(p16172.frames) || 0, 0, 100);
      p16172.frameT = UTILS.limitMM(parseFloat(p16172.frameT) || 0, 0, 10).round(1) * 100;
    }
    p16172.texEncode = UTILS.limitMM(p16172.texEncode, 0, config.encodingTypes.length - 1);
    p16172.alphaTest = UTILS.limitMM(parseInt(p16172.alphaTest) || 0, 0, 1).round(2);
    if (p16172.interface) {
      p16172.interface = UTILS.limitMM(p16172.interface, 0, config.interfaceIDMax);
    }
    if (p16172.interfaceT) {
      p16172.interfaceT = UTILS.limitMM(p16172.interfaceT, 0, config.interfaceIDMax);
    }
    if (p16172.health) {
      p16172.canDest = true;
    }
    p16172.spawnChance = UTILS.limitMM(parseFloat(p16172.spawnChance) || 0, 0, 100).round(2);
    if (!p16172.spawnChance) {
      p16172.spawnChance = undefined;
    }
    if (p16172.complexColl && p16172.canDest) {
      p16172.complexColl = false;
    }
    if (!p16172.noCol) {
      this.objects.push(new GameObject({
        x: p16167,
        z: p16169,
        y: p16168,
        w: p16170,
        l: p16171,
        h: 0,
        uid: this.objects.length,
        s: p16172.sound || undefined,
        health: p16172.health || undefined,
        notWallJ: p16172.notWallJ,
        noGrapple: p16172.noGrapple,
        noShoot: !!p16172.noShoot || undefined,
        noAICol: !!p16172.noAICol || undefined,
        noImpulse: p16172.noImpulse,
        respawnT: UTILS.isNumber(p16172.respawnT) && p16172.respawnT > 0 ? p16172.respawnT : undefined,
        respawnR: p16172.respawnR,
        transparent: !!p16172.transparent || !!UTILS.isTransTex(p16172.src) || undefined,
        penetrable: p16172.penetrable > 0 ? p16172.penetrable : undefined,
        noVis: p16172.noVis,
        noAmb: p16172.noAmb,
        interface: p16172.interface,
        canDest: p16172.canDest,
        complexColl: !!p16172.complexColl || undefined,
        startDest: p16172.canDest && p16172.startDest,
        spawnChance: p16172.spawnChance,
        noMinimap: p16172.noMinimap
      }));
    }
    if (!p16172.noCol && !p16172.noise && p16172.side != 2 && !p16172.asset) {
      this.objects[this.objects.length - 1].type = 1;
    }
    this.addHelpers(p16172, this.objects.length - 1);
    if (RENDER && !p16172.noVis) {
      p16172.refl = 1;
      p16172.noEmisTex = true;
      p16172.transparent = p16172.fTrans || UTILS.isTransTex(p16172.src) || p16172.opacity != 1;
      if (UTILS.isTransTex(p16172.src)) {
        p16172.depthWrite = p16172.opacity == 1;
        p16172.alphaTest = p16172.transparent ? 0.02 : 0;
      }
      p16172.side = THREE.DoubleSide;
      p16172.vertexColors = true;
      p16172.shadowsR = true;
      if (p16172.noise) {
        p16172.pinEdges = true;
        p16172.margin = 5;
        p16172.tilesX = Math.round(p16171 / 5);
        p16172.tilesZ = Math.round(p16170 / 5);
      }
      p16172.noShader = !!p16172.noise;
      var vA709 = [p16167, p16168, p16169, p16170, p16171, p16172, p16173, p16174, p16175];
      if (p16172.noise) {
        if ((p16172.health || p16172.canDest) && !p16172.noCol) {
          vA709.push(this.objects.length - 1);
        }
        vA707.push(vA709);
      } else {
        var v12878;
        if (p16172.mimicSprite) {
          p16172.color = p16172.colr || "#FFFFFF";
          p16172.mat = THREE.SpriteMaterial;
          v12878 = RENDER.addSprite(p16167, p16168, p16169, p16170, p16171, p16172);
        } else {
          v12878 = RENDER.addFixedPlane(...vA709);
        }
        if ((p16172.health || p16172.canDest) && !p16172.noCol) {
          this.objects[this.objects.length - 1].meshRef = v12878;
        }
      }
    }
  };
  this.addSprite = function (p16176, p16177, p16178, p16179, p16180, p16181) {
    p16181 = p16181 || {};
    if (p16181.texOffX) {
      p16181.texOffX = UTILS.limitMM(p16181.texOffX, 0, 1).round(2);
    }
    if (p16181.texOffY) {
      p16181.texOffY = UTILS.limitMM(p16181.texOffY, 0, 1).round(2);
    }
    if (p16181.frames) {
      p16181.frames = UTILS.limitMM(parseInt(p16181.frames) || 0, 0, 100);
      p16181.frameT = UTILS.limitMM(parseFloat(p16181.frameT) || 0, 0, 10).round(1) * 100;
    }
    p16181.texEncode = UTILS.limitMM(p16181.texEncode, 0, config.encodingTypes.length - 1);
    if (RENDER && !p16181.noVis) {
      p16181.color = p16181.colr || "#FFFFFF";
      p16181.mat = THREE.SpriteMaterial;
      p16181.noEmisTex = true;
      p16181.transparent = true;
      p16181.side = THREE.DoubleSide;
      p16181.vertexColors = true;
      p16181.shadowsR = true;
      RENDER.addSprite(p16176, p16177, p16178, p16179, p16180, p16181);
    }
  };
  this.addLiquid = function (vLN02299, p16183, p16184, p16185, p16186, p16187, p16188, p16189, p16190) {
    if (RENDER && !p16187.noVis && RENDER.mapDet) {
      p16187 = p16187 || {};
      p16187.texOffX = UTILS.limitMM(p16187.texOffX, 0, 1).round(2);
      p16187.texOffY = UTILS.limitMM(p16187.texOffY, 0, 1).round(2);
      p16187.texRot = UTILS.limitMM(p16187.texRot, 0, 360);
      p16187.texEncode = UTILS.limitMM(p16187.texEncode, 0, config.encodingTypes.length - 1);
      p16187.noEmisTex = true;
      p16187.shadowsR = true;
      p16187.transparent = p16187.opacity != 1;
      p16187.side = THREE.DoubleSide;
      p16187.scale = 2;
      p16187.vertexColors = true;
      p16187.noGroup = true;
      p16187.tilesX = p16187.tilesX || 10;
      p16187.tilesZ = p16187.tilesZ || 10;
      p16187.noShader = true;
      p16187.mat = THREE.StrippedLambertMaterial;
      var v12879 = RENDER.addFixedPlane(vLN02299, p16183, p16184, p16185, p16186, p16187, p16188, p16189, p16190);
      var v12880 = v12879.geometry.getAttribute("position");
      const v12881 = new Float32Array(v12880.count);
      for (var vLN02299 = 0; vLN02299 < v12880.count; vLN02299++) {
        v12881[vLN02299] = vLN02299;
      }
      v12879.geometry.setAttribute("count", new THREE.BufferAttribute(v12881, 1));
      RENDER.liquids.push({
        mesh: v12879,
        spd: p16187.wSpeed || 10,
        hght: p16187.wHeight || 0.5
      });
    }
  };
  this.pointInObjs = function (p16191, p16192, p16193) {
    for (var vLN02300 = 0; vLN02300 < this.objects.length; ++vLN02300) {
      v12693 = this.objects[vLN02300];
      if (!v12693.noVis && !v12693.complexMesh && !v12693.health && !v12693.canDest && p16192.indexOf(v12693.sid) < 0 && UTILS.pointInBox3D(p16191[0], p16191[1], p16191[2], v12693, p16193 || 0)) {
        return true;
      }
    }
    return false;
  };
  this.setMaxAO = function (p16194, p16195, p16196) {
    p16194.maxAOS = p16194.maxAOS || {};
    p16194.maxAOS[p16195.sid] = Math.max(p16196, p16194.maxAOS[p16195.sid] || 0);
    p16195.maxAOS = p16195.maxAOS || {};
    p16195.maxAOS[p16194.sid] = Math.max(p16196, p16195.maxAOS[p16194.sid] || 0);
  };
  this.aosToAdd = {};
  this.addAmbient = function (p16197, p16198, p16199, p16200, p16201, p16202, p16203, p16204, p16205, p16206, p16207) {
    if (!RENDER.noTex) {
      var v12882 = !p16206;
      if (p16206) {
        for (var vLN02301 = 0; vLN02301 < p16206.length; ++vLN02301) {
          if (UTILS.pointInBox3D(p16197, p16198, p16199, p16206[vLN02301], config.ambOff * 2)) {
            v12882 = true;
            break;
          }
        }
      }
      if (v12882) {
        if (p16206) {
          var v12883 = p16206[0].sid + "-" + p16206[1].sid;
          if (!this.aosToAdd[v12883]) {
            this.aosToAdd[v12883] = [];
          }
          this.aosToAdd[v12883].push({
            vals: [p16197, p16198, p16199, p16200, p16201, p16202, p16203 + config.ambOff, p16204 + config.ambOff, p16205],
            group: p16207
          });
        } else {
          this.addPlane(p16197, p16198, p16199, p16203, p16204, {
            src: "ambient_" + (p16205 || 0),
            euler: "ZYX",
            depthWrite: false,
            noCol: true
          }, p16200, p16201, p16202);
        }
      }
    }
  };
  var vA710 = [["g6-1-2", "g4-1-2"], ["g5-1-2", "g4-0-1"], ["g6-0-1", "g3-1-2"], ["g5-0-1", "g3-0-1"], ["g6-0-3", "g2-0-3"], ["g5-0-3", "g2-1-1"], ["g6-1-1", "g1-0-3"], ["g5-1-1", "g1-1-1"], ["g6-0-2", "g1-1-0"], ["g5-0-2", "g1-0-2"], ["g6-1-0", "g2-1-0"], ["g5-1-0", "g2-0-2"], ["g4-0-2", "g1-0-0"], ["g3-0-2", "g1-1-3"], ["g4-1-0", "g2-0-0"], ["g3-1-0", "g2-1-3"], ["g4-0-3", "g2-1-2"], ["g3-0-3", "g2-0-1"], ["g4-1-1", "g1-1-2"], ["g3-1-1", "g1-0-1"], ["g6-1-3", "g3-0-0"], ["g5-1-3", "g3-1-3"], ["g6-0-0", "g4-0-0"], ["g5-0-0", "g4-1-3"]];
  this.groupsMatch = function (p16208, p16209) {
    for (var vLN02302 = 0; vLN02302 < vA710.length; ++vLN02302) {
      if (vA710[vLN02302].indexOf(p16208) >= 0 && vA710[vLN02302].indexOf(p16209) >= 0) {
        return true;
      }
    }
    return false;
  };
  this.clearAOGroup = function (p16210) {
    for (var v12884 = p16210.length - 1; v12884 >= 0; --v12884) {
      v12693 = p16210[v12884];
      for (var v12885 = p16210.length - 1; v12885 >= 0; --v12885) {
        v12694 = p16210[v12885];
        if (!v12693.dontAdd && !v12694.dontAdd && v12693 != v12694 && this.groupsMatch(v12693.group, v12694.group)) {
          if (v12693.vals[6] + v12693.vals[7] >= v12694.vals[6] + v12694.vals[7]) {
            v12694.dontAdd = true;
          } else {
            v12693.dontAdd = true;
          }
          break;
        }
      }
    }
  };
  this.addPendingAOs = function () {
    for (var v12886 in this.aosToAdd) {
      if (this.aosToAdd.hasOwnProperty(v12886)) {
        this.clearAOGroup(this.aosToAdd[v12886]);
        for (var vLN02303 = 0; vLN02303 < this.aosToAdd[v12886].length; ++vLN02303) {
          if (!this.aosToAdd[v12886][vLN02303].dontAdd) {
            this.addAmbient(...this.aosToAdd[v12886][vLN02303].vals);
          }
        }
      }
    }
    this.aosToAdd = {};
  };
  this.limitAmb = function (p16211, p16212, p16213, p16214, p16215, p16216, p16217) {
    var vA711 = [UTILS.cdv[p16214]];
    var vA712 = [UTILS.cdv[p16215]];
    p16211 = p16213 == -Math.PI / 2 || p16213 == Math.PI + Math.PI / 2 ? Math.min(p16211, (p16212[p16215] - Math.min(p16216[p16215] - p16216[vA712], p16217[p16215] - p16217[vA712])) / 2) : p16213 == Math.PI / 2 ? Math.min(p16211, (Math.max(p16216[p16215] + p16216[vA712], p16217[p16215] + p16217[vA712]) - p16212[p16215]) / 2) : p16213 == 0 ? Math.min(p16211, (Math.max(p16216[p16214] + p16216[vA711], p16217[p16214] + p16217[vA711]) - p16212[p16214]) / 2) : Math.min(p16211, (p16212[p16214] - Math.min(p16216[p16214] - p16216[vA711], p16217[p16214] - p16217[vA711])) / 2);
    return p16211;
  };
  this.resetAll = function (p16218) {
    this.aosToAdd = {};
    this.destObjs.length = 0;
    this.movedObjs.length = 0;
    for (var vLN02304 = 0; vLN02304 < this.objects.length; ++vLN02304) {
      if (this.objects[vLN02304]) {
        var v12887 = !this.objects[vLN02304].startClosed && !this.objects[vLN02304].startDest && !this.objects[vLN02304].mysteryBox;
        this.objects[vLN02304].active = v12887;
        this.objects[vLN02304].destroyed = !!this.objects[vLN02304].startDest;
        if (this.objects[vLN02304].startHealth) {
          this.objects[vLN02304].health = this.objects[vLN02304].startHealth;
        }
        if ((this.objects[vLN02304].health || this.objects[vLN02304].canDest) && this.objects[vLN02304].startDest) {
          this.objects[vLN02304].destroyed = true;
          this.objects[vLN02304].active = false;
        }
        if (!p16218 && !RENDER && this.objects[vLN02304].spawnChance && this.objects[vLN02304].startDest && this.objects[vLN02304].canDest && UTILS.randFloat(0, 100) <= this.objects[vLN02304].spawnChance) {
          this.objects[vLN02304].destroyed = false;
          this.objects[vLN02304].active = true;
        }
        if (this.objects[vLN02304].destroyed) {
          this.destObjs.push(this.objects[vLN02304].uid);
        }
        this.objects[vLN02304].storage = 0;
        this.objects[vLN02304].triggered = false;
        if (this.objects[vLN02304].eventN) {
          this.objects[vLN02304].trigT = (this.objects[vLN02304].trigConstE || 1) * 1000;
        }
        if (this.objects[vLN02304].uses) {
          this.objects[vLN02304].uses.length = 0;
        }
        if (this.objects[vLN02304].respawnTStart != null) {
          this.objects[vLN02304].respawnT = this.objects[vLN02304].respawnTStart;
        }
        if (this.objects[vLN02304].meshRef) {
          this.objects[vLN02304].meshRef.visible = !!this.objects[vLN02304].active;
        }
        this.objects[vLN02304].custVals = {};
        if (this.objects[vLN02304].perkMachine) {
          this.objects[vLN02304].gotFreeP = false;
        }
      }
    }
    if (RENDER) {
      RENDER.updateShadowMap();
    }
  };
  this.syncAll = function (p16219) {
    this.destObjs = p16219 && p16219.length ? p16219 : [];
    for (var vLN02305 = 0; vLN02305 < this.objects.length; ++vLN02305) {
      if (this.objects[vLN02305].destroyed && this.destObjs.indexOf(this.objects[vLN02305].uid) == -1 && !this.objects[vLN02305].mysteryBox) {
        this.objects[vLN02305].destroyed = false;
        this.objects[vLN02305].active = true;
        if (this.objects[vLN02305].meshRef) {
          this.objects[vLN02305].meshRef.visible = true;
        }
      }
    }
    if (RENDER) {
      RENDER.updateShadowMap();
    }
  };
  this.removeAll = function () {
    this.objects.length = 0;
    this.grids = {};
    this.pathNodes = {};
    this.objectives.length = 0;
    this.domzones.length = 0;
    this.scorezones.length = 0;
    this.sites.length = 0;
    this.flags.length = 0;
    this.spawnables.length = 0;
    this.pickups.length = 0;
    this.gates.length = 0;
    this.mysteryBoxes.length = 0;
    this.perkMachines.length = 0;
    this.krumMachines.length = 0;
    this.banks.length = 0;
    this.pendingAIs.length = 0;
    this.pendingBots.length = 0;
    this.pendingLeaders.length = 0;
    this.teleporters.length = 0;
    this.timerObjs.length = 0;
    this.playerObjs.length = 0;
    this.spectateCams = {};
    this.envZones.length = 0;
    this.pendingTriangles.length = 0;
    this.serverNodes.length = 0;
    this.mapAnchors.length = 0;
  };
};